/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { useState, useEffect, useCallback, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { MdOutlineContentCopy } from "react-icons/md";
import { MdArrowBackIosNew } from "react-icons/md";
import { MdTranslate } from "react-icons/md";
import { FaFileExport } from "react-icons/fa";
import { GrValidate } from "react-icons/gr";
import LogoMangas from "../../assets/logo mangasio.svg";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { IoSettingsSharp } from "react-icons/io5";
import { FaBell } from "react-icons/fa";
import { FaRegComment } from "react-icons/fa6";
import { PiMagicWandFill } from "react-icons/pi";
import axios from "axios";
import dog_logo from "../../assets/edition_logo.png";
import TextZone from "../text_zone/TextZone";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import domtoimage from "dom-to-image-more";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import detection from "../../assets/bubbles_detection_icon.png";
import show_due from "../../assets/show_due.png";
import { debounce } from "lodash";
import socket from "../../services/socket";
import SpotElements from "../spote/SpoteElements";
import { IoIosEye } from "react-icons/io";
import { IoIosEyeOff } from "react-icons/io";

import DocumentTitle from "../../utils/DocumentTitle";

const Edition = () => {
  DocumentTitle("Mangas.IO translator");
  // get tome id from param
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLogedin, setIsLogedIn] = useState(false);
  const [currentTome, setCurrentTome] = useState(null);
  const [currentTomePrime, setCurrentTomePrime] = useState(null);
  const [selectedSousDocsId, setSelectedSousDocsId] = useState();
  const [sousDocs, setSousDocs] = useState([]);
  const [imgs, setImgs] = useState([]);
  const [activeImg, setActiveImg] = useState("");
  const [activeImgIdx, setActiveImgIdx] = useState("");
  const [getCoords, setGetCoords] = useState("Detect bubbles");
  const [iaCoords, setIaCoords] = useState([]);
  const [coordsSelectedImg, setCoordsSelectedImg] = useState(null);
  const [coordsSelectedImgStored, setCoordsSelectedImgStored] = useState(null);
  const thisPage = useRef();
  const [imageWidth, setImageWidth] = useState(0);
  const [imageHeight, setImageHeight] = useState(0);
  const [originalWidth, setOriginalWidth] = useState(0);
  const [originalHeight, setOriginalHeight] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [zoneRemoved, setZoneRemoved] = useState("");
  const [emptyBubbleImg, setEmptyBubbleImg] = useState(null);
  const [selectedTrans, setSelectedTrans] = useState({});
  const [selectedTransTwo, setSelectedTransTwo] = useState({});
  const [getTrans, setGetTrans] = useState();
  const [hasTrans, setHasTrans] = useState(false);
  const [exportList, setExportList] = useState(false);
  // const [exportListVO, setExportListVO] = useState(false);
  const [getEmpty, setGetEmpty] = useState({});
  const [isTranslated, setIsTranslated] = useState("Launch translation");
  const [transDone, setTransDone] = useState(false);
  const [openImportedFile, setOpenImportedFile] = useState(false);
  const [fileToImport, setFileToImport] = useState(null);
  const [isUploaded, setIsUploaded] = useState(false);
  const [uploadDone, setUploadDone] = useState("");
  const [textIsUpdated, setTextIsUpdated] = useState(false);
  const [showDue, setShowDue] = useState(false);
  const [showVO, setShowVO] = useState(false);
  const [showExportPdf, setShowExportPdf] = useState(false);
  const [allErasedImgs, setAllErasedImgs] = useState([]);
  const [allTrans, setAllTrans] = useState([]);
  const [progress, setProgress] = useState(0);
  const [pageValidated, setPageValidated] = useState("");
  const [allSousDocsValid, setAllSousDocsValid] = useState(null);
  const [showHideSlide, setShowHideSlide] = useState(true);
  const [allTextsValid, setAllTextsValid] = useState(false);
  const [loggedUser, setLoggedUser] = useState({});
  const [validationText, setValidationText] = useState("Skip detection");
  const [validationPage, setValidationPage] = useState(false);
  const [showProgress, setShowProgress] = useState(false);
  const [relatedSerie, setRelatedSerie] = useState({});
  const [showSettings, setShowSettings] = useState(false);
  const [showExport, setShowExport] = useState(true);
  const [showUsers, setShowUsers] = useState(false);
  const [showPolice, setShowPolice] = useState(false);
  const [group, setGroup] = useState();
  const [usersActive, setUsersActive] = useState([]);
  const [usersOnline, setUsersOnline] = useState([]);
  const [toggleNotif, setToggleNotif] = useState(false);
  const [fontsDefault, setFontsDefault] = useState(null);
  // const [pageStatusUpdated, setPageStatusUpdated] = useState(null);
  const [transStatusUpdated, setTransStatusUpdated] = useState("");
  const [spots, setSpots] = useState(0);

  // Resize logic start
  const [draggingId, setDraggingId] = useState(null);
  const [resizingId, setResizingId] = useState(null);
  const [rotatingId, setRotatingId] = useState(null);
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  const [coordsToSend, setCoordsToSend] = useState({});
  const [coordID, setCoordID] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [newNotifications, setNewNotifications] = useState([]);
  const [coordsUpdated, setCoordsUpdated] = useState(null);
  const [keepIdx, setKeepIdx] = useState(null);
  const [defaultPolice, setDefaultPolice] = useState({});
  const [imageLoaded, setImageLoaded] = useState(false);
  const [getNow, setGetNow] = useState(null);
  const [startAngle, setStartAngle] = useState(0);
  const [initialRotation, setInitialRotation] = useState(0);
  const [bubbleAll, setBubbleAll] = useState({ val: false });
  const [bubbleAllSpin, setBubbleAllSpin] = useState(false);
  const [transAll, setTransAll] = useState({ val: false });
  const [transAllSpin, setTransAllSpin] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isForceValidation, setIsForceValidation] = useState(false);
  const [isForceValidationDone, setIsForceValidationDone] = useState("");
  const [pageNumReady, setPageNumReady] = useState("");
  const [previewExport, setPreviewExport] = useState(false);
  const [previewExportReady, setPreviewExportReady] = useState(false);
  const toRem = parseFloat(getComputedStyle(document.documentElement).fontSize);

  // get all notifications
  useEffect(() => {
    try {
      const token = localStorage.getItem("login_token");
      const user = JSON.parse(localStorage.getItem("login_user"));
      if (token && user) {
        axios
          .get(
            `${process.env.REACT_APP_HOST_API}/api/notification/get/${user.id}`,
            {
              headers: { Authorization: token },
            }
          )
          .then((res) => {
            let newOnes = res.data.filter((n) => n.statut === "sent");
            setNewNotifications([...newOnes]);
            setNotifications([...res.data]);
            console.log("res notifications : ", res.data);
          });
      }
    } catch (error) {
      toast.error("Can't get notifications");
    }
  }, []);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (draggingId !== null) {
        setKeepIdx(draggingId);
        let spot = document.getElementById(`spote-${draggingId}`);
        const newPosX = e.clientX - offset.x;
        const newPosY = e.clientY - offset.y;

        spot.style.left = `${newPosX}px`;
        spot.style.top = `${newPosY}px`;

        // setElements((prevElements) => ({
        //     ...prevElements,
        //     [draggingId]: {
        //         ...prevElements[draggingId],
        //         x: newPosX,
        //         y: newPosY,
        //     },
        // }));
        let newCoords = {
          X: (newPosX * originalWidth) / imageWidth,
          Y: (newPosY * originalHeight) / imageHeight,
          W: coordsToSend?.W
            ? coordsToSend?.W
            : selectedTrans.sous_images[draggingId].coord.W,
          H: coordsToSend?.H
            ? coordsToSend?.H
            : selectedTrans.sous_images[draggingId].coord.H,
          R: coordsToSend?.R
            ? coordsToSend?.R
            : selectedTrans.sous_images[draggingId].coord.R,
        };
        setCoordsToSend({ ...newCoords });
        // console.log(`change drag x : ${(newPosX * originalWidth) / imageWidth} and y : ${(newPosY * originalHeight) / imageHeight} o_x : ${selectedTrans.sous_images[draggingId].coord.X} o_y : ${selectedTrans.sous_images[draggingId].coord.Y} draggingId : ${draggingId} newCoords : `, newCoords)
        setCoordID(selectedTrans.sous_images[draggingId].id_sous_image);
        console.log(`change drag newCoords : `, newCoords);
        console.log(
          "change selectedTrans",
          selectedTrans.sous_images[draggingId]
        );

        // let newObj = {...coordsSelectedImg};
        // newObj.sous_images[draggingId].coord = newCoords;
        // console.log('drag new obj : ', newObj)
        // setCoordsSelectedImg(newObj);
      } else if (resizingId !== null) {
        setKeepIdx(resizingId);
        const element = document.getElementById(`spote-${resizingId}`);
        // const resizer = document.getElementById(`resizer-${resizingId}`);

        const newWidth = e.clientX - element.getBoundingClientRect().left;
        const newHeight = e.clientY - element.getBoundingClientRect().top;

        element.style.width = `${newWidth}px`;
        element.style.height = `${newHeight}px`;

        let newCoords = {
          X: coordsToSend?.X
            ? coordsToSend.X
            : selectedTrans.sous_images[resizingId].coord.X,
          Y: coordsToSend?.Y
            ? coordsToSend.Y
            : selectedTrans.sous_images[resizingId].coord.Y,
          W: (newWidth * originalWidth) / imageWidth,
          H: (newHeight * originalHeight) / imageHeight,
          R: coordsToSend?.R
            ? coordsToSend?.R
            : selectedTrans.sous_images[resizingId].coord.R,
        };
        setCoordsToSend({ ...newCoords });

        // console.log(`change resize w : ${(newWidth * originalWidth) / imageWidth} and h : ${(newHeight * originalHeight) / imageHeight} o_w : ${selectedTrans.sous_images[resizingId].coord.W} o_h : ${selectedTrans.sous_images[resizingId].coord.H} resizingId : ${resizingId} newCoords : `, newCoords)
        console.log(`change resize newCoords : `, newCoords);
        setCoordID(selectedTrans.sous_images[resizingId].id_sous_image);
        // setElements((prevElements) => ({
        //     ...prevElements,
        //     [resizingId]: {
        //         ...prevElements[resizingId],
        //         width: newWidth > 50 ? newWidth : 50,
        //         height: newHeight > 50 ? newHeight : 50,
        //     },
        // }));
      } else if (rotatingId !== null) {
        setKeepIdx(rotatingId);
        const element = document.getElementById(`spote-${rotatingId}`);
        const rect = element.getBoundingClientRect();
        const centerX = rect.left + rect.width / 2;
        const centerY = rect.top + rect.height / 2;
        const angle =
          Math.atan2(e.clientY - centerY, e.clientX - centerX) *
          (180 / Math.PI);
        const angleDifference = angle - startAngle;
        element.style.transform = `rotate(${
          angleDifference + initialRotation
        }deg)`;

        let newCoords = {
          X: coordsToSend?.X
            ? coordsToSend.X
            : selectedTrans.sous_images[rotatingId].coord.X,
          Y: coordsToSend?.Y
            ? coordsToSend.Y
            : selectedTrans.sous_images[rotatingId].coord.Y,
          W: coordsToSend?.W
            ? coordsToSend?.W
            : selectedTrans.sous_images[rotatingId].coord.W,
          H: coordsToSend?.H
            ? coordsToSend?.H
            : selectedTrans.sous_images[rotatingId].coord.H,
          R: angleDifference,
        };
        setCoordsToSend({ ...newCoords });

        // console.log(`change rotate w : ${(newWidth * originalWidth) / imageWidth} and h : ${(newHeight * originalHeight) / imageHeight} o_w : ${selectedTrans.sous_images[resizingId].coord.W} o_h : ${selectedTrans.sous_images[resizingId].coord.H} resizingId : ${resizingId} newCoords : `, newCoords)
        setCoordID(selectedTrans.sous_images[rotatingId].id_sous_image);
        console.log(`change rotate newCoords : `, newCoords);
        console.log(
          `change rotate selectedTrans : `,
          selectedTrans.sous_images[rotatingId]
        );
      }
    };

    const handleMouseUp = () => {
      setDraggingId(null);
      setResizingId(null);
      setRotatingId(null);
      setCoordID(null);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [offset, draggingId, resizingId, rotatingId]);

  const handleMouseDown = (e, i, type) => {
    e.stopPropagation();
    const div = document.getElementById(`spote-${i}`);

    if (type === "drag") {
      setDraggingId(i);
      setOffset({
        x: e.clientX - div.offsetLeft,
        y: e.clientY - div.offsetTop,
      });
    } else if (type === "resize") {
      setResizingId(i);
    } else if (type === "rotate") {
      const rect = div.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      const angle =
        Math.atan2(e.clientY - centerY, e.clientX - centerX) * (180 / Math.PI);

      setRotatingId(i);
      setStartAngle(angle);
      setInitialRotation(div.rotation || 0);
    }
  };
  console.log(
    "coordsToSend : ",
    coordsToSend,
    " idx : ",
    draggingId,
    " ",
    resizingId,
    " ",
    rotatingId,
    " coordID",
    coordID
  );
  // Resize logic end

  // Debounced function to update data in the database
  const updateDataInDatabase = useCallback(
    debounce((coordID, coordsToSend, idx, selectedTrans) => {
      if (coordID !== null) {
        console.log(
          "from debounce : ",
          coordID,
          " coordsToSend : ",
          coordsToSend
        );
        const token = localStorage.getItem("login_token");
        if (token) {
          let transCoords = { ...selectedTrans };
          transCoords.sous_images[idx].coord = coordsToSend;
          setCoordsUpdated(Math.random());
          setSelectedTransTwo({ ...transCoords });
          setCoordsToSend({});
          try {
            axios
              .put(
                `${process.env.REACT_APP_HOST_API}/api/translation/textMangaFromCoord/${coordID}/update`,
                coordsToSend,
                {
                  headers: { Authorization: token },
                }
              )
              .then((res) => {
                console.log("res update coord : ", res);
                setCoordsUpdated(Math.random());
                // console.log('res update idx : ', idx);
                // let transCoords = { ...selectedTrans };
                // console.log('res update transCoords : ', transCoords);
                // transCoords.sous_images[idx].coord = coordsToSend;
                // setCoordsUpdated(res.data);
                // setCoordsToSend({});
                // setSelectedTransTwo({ ...transCoords });
                // if (res.status === 200) {
                //     setCoordsUpdated(res.data._id)
                //     console.log('res update coord : ', res);
                //     let newObj = { ...coordsSelectedImgStored };
                //     console.log('newObj : ', newObj)
                //     console.log('idx : ', idx)
                //     console.log('coordsToSend : ', coordsToSend)
                //     if (newObj?.sous_images && idx && coordsToSend) {
                //         newObj.sous_images[idx].coord = coordsToSend;
                //         console.log('newObj : ', newObj)
                //         setCoordsSelectedImg(newObj)
                //     }
                // }
              });
          } catch (error) {
            console.log("update coord err : ", error);
          }
        }
      }
    }, 150),
    []
  );
  // Effect to run when `data` state changes
  useEffect(() => {
    if (coordID !== null && coordsToSend !== null) {
      updateDataInDatabase(coordID, coordsToSend, keepIdx, selectedTrans);
    }
  }, [
    coordsToSend?.X,
    coordsToSend?.Y,
    coordsToSend?.W,
    coordsToSend?.H,
    coordsToSend?.R,
    updateDataInDatabase,
  ]);

  const toggleListSetting = (e) => {
    let id = e.target.id;

    if (id === "export") {
      setShowExport(true);
      setShowUsers(false);
      setShowPolice(false);
    } else if (id === "users") {
      setShowExport(false);
      setShowUsers(true);
      setShowPolice(false);
    } else if (id === "police") {
      setShowExport(false);
      setShowUsers(false);
      setShowPolice(true);
    }
  };

  const selectedImg = (e) => {
    setEmptyBubbleImg(null);
    setValidationPage(false);
    setImageLoaded(false);
    if (showDue) {
      showDueHandler();
    }
    // console.log("active path : ", e.target.alt)
    setSelectedTrans(() => ({}));
    setActiveImg(e.target.src);
    setActiveImgIdx(e.target.alt);
    setPageNum(e.target.id);
    // console.log('iaCoords : ', iaCoords)
    // console.log('nompage : ', e.target.id)
    selectedImgDB(e.target.alt);
    // checkValidationOfTexts(coordsSelectedImg?.sous_images)
    let pages = [...document.querySelectorAll(".pageNum")];
    let pagesHover = [...document.querySelectorAll(".splitted_img")];
    let idImage = e.target.id;
    // console.log('image id : ', idImage)
    // console.log('image spots  : ', spots)
    pages.forEach((page) => {
      if (idImage === page.innerHTML) {
        page.style.color = "orange";
      } else {
        page.style.color = "";
      }
    });

    pagesHover.forEach((page) => {
      if (idImage === page.id) {
        page.style.backgroundColor = "#88878729";
        let i = idImage - 1;
        if (
          sousDocs[i].page_status === "auto" ||
          (sousDocs[i].page_status === "done" &&
            sousDocs[i].trans_status === "done")
        ) {
          setImageLoaded(true);
        }
        // console.log('this image clicked : ', coordsSelectedImg)
        // console.log('this image idImage : ', idImage)
        // console.log('this image sousDocs : ', sousDocs[i].page_status)
        // console.log('this image sousDocs : ', sousDocs[i])
      } else {
        page.style.backgroundColor = "";
      }
    });
  };

  const checkValidationOfDoc = (allDocs) => {
    if (allDocs.length !== 0) {
      let allPagesValid = true;
      setAllSousDocsValid(true);
      console.log("all Pages Valid top : ", allPagesValid);
      for (let i = 0; i < allDocs.length; i++) {
        if (
          allDocs[i].validation === false ||
          allDocs[i].validation === undefined ||
          allDocs[i].validation === ""
        ) {
          setAllSousDocsValid(false);
          allPagesValid = false;
          break;
        }
      }
      if (
        allPagesValid &&
        currentTome?.tome?.statut !== "validated" &&
        currentTome?.tome?._id
      ) {
        const token = localStorage.getItem("login_token");
        const tomeID = currentTome?.tome?._id;
        console.log("all Pages Valid : ", allPagesValid);
        console.log("all Pages Valid tomeID : ", tomeID);
        if (token) {
          try {
            axios
              .put(
                `${process.env.REACT_APP_HOST_API}/api/tome/validateTome/${tomeID}`,
                {},
                {
                  headers: { Authorization: token },
                }
              )
              .then((res) => {
                console.log("update tome statut to validated : ", res);
              });
          } catch (error) {
            console.log("all Pages Valid err : ", error);
          }
        }
      }
    }
  };

  const checkValidationOfTexts = (selectedPage) => {
    let allTexts = 0;
    if (selectedPage.length !== 0) {
      for (let i = 0; i < selectedPage.length; i++) {
        if (selectedPage[i]?.traduction_validee) {
          allTexts++;
        } else {
          break;
        }
      }
      if (selectedPage.length === allTexts) {
        let newSousDocs = [...sousDocs];
        newSousDocs[pageNum - 1].validation = true;
        setSousDocs([...newSousDocs]);
      }
    }
  };

  // check page has comment
  const pageHasComment = () => {
    let idx = pageNum - 1;
    if (idx >= 0 && sousDocs[idx].hasComment === false) {
      let newSousDocs = [...sousDocs];
      newSousDocs[idx].hasComment = true;
      setSousDocs([...newSousDocs]);
      console.log("commented page : ", newSousDocs);
    }
  };

  // check page status
  const pageStatus = (status) => {
    let idx = pageNum - 1;
    if (idx >= 0) {
      if (status === "b") {
        let newSousDocs = [...sousDocs];
        newSousDocs[idx].page_status = "done";
        setSousDocs([...newSousDocs]);
      } else if (status === "t") {
        let newSousDocs = [...sousDocs];
        newSousDocs[idx].trans_status = "trans";
        setSousDocs([...newSousDocs]);
      }
    }
  };

  const skipAndValidate = () => {
    let newSousDocs = [...sousDocs];
    newSousDocs[pageNum - 1].validation = true;
    setSousDocs(newSousDocs);
  };

  // filter two arrays
  function getMatchingElements(arr1, arr2) {
    return arr1.filter((item1) =>
      arr2.some((item2) => item2._id === item1._id)
    );
  }

  // get equipe
  useEffect(() => {
    if (currentTome) {
      const token = localStorage.getItem("login_token");
      if (token) {
        try {
          axios
            .get(
              `${process.env.REACT_APP_HOST_API}/api/serie/${currentTome?.tome?.fk_serie}/users`,
              {
                headers: { Authorization: token },
              }
            )
            .then((res) => {
              // console.log('group : ', res.data)
              setGroup(res.data);
            });
        } catch (error) {
          if (
            error.response.status === 400 ||
            error.response.status === 500 ||
            error.response.status === 401
          ) {
            toast.error("Something wrong while getting assigned users");
          }
        }
      }
    }
  }, [currentTome]);

  // get Default police
  useEffect(() => {
    const token = localStorage.getItem("login_token");
    if (showSettings && currentTome?.tome?._id) {
      if (token) {
        // get police default
        try {
          axios
            .get(
              `${process.env.REACT_APP_HOST_API}/api/translation/defaultPolice/${currentTome?.tome?._id}/get`,
              {
                headers: { Authorization: token },
              }
            )
            .then((res) => {
              // console.log('group : ', res.data)
              setDefaultPolice({ ...res.data });
            });
        } catch (error) {
          toast.error("Something wrong while getting default police");
          console.log("get default police err : ", error);
        }
      }
    }
  }, [showSettings]);

  useEffect(() => {
    if (selectedTrans?.sous_images) {
      checkValidationOfTexts(selectedTrans.sous_images);
    }
  }, [allTextsValid, selectedTrans?.sous_images]);

  // remove validation from page
  const unvalidatePage = () => {
    console.log("selected sous docs idx : ", pageNum - 1);
    console.log("selected sous docs : ", sousDocs);
    let newSousDocs = [...sousDocs];
    let newCoordSelectedImg = { ...coordsSelectedImg };
    let idx = pageNum - 1;
    newSousDocs[idx].validation = false;
    newCoordSelectedImg.validation = false;
    setSousDocs([...newSousDocs]);
    setCoordsSelectedImgStored({ ...newCoordSelectedImg });
  };

  const selectedImgDB = (path) => {
    let x = `${iaCoords.id_parent}/${iaCoords.page_name}`;
    // console.log('x : ', x)
    if (x === path) {
      setCoordsSelectedImg(iaCoords);
      setCoordsSelectedImgStored(iaCoords);
    } else {
      setCoordsSelectedImg(null);
      setCoordsSelectedImgStored(null);
    }

    sousDocs?.map((el) => {
      if (el.chemin === path) {
        setSelectedSousDocsId(el._id);
      }
    });
  };
  // console.log('selected sous doc id : ', selectedSousDocsId)
  // render image
  const renderImage = async (sousDocs) => {
    var sousDocsSorted = sousDocs.sort((a, b) => a.page - b.page);
    var list = [];
    const token = localStorage.getItem("login_token");
    for (let i = 0; i < sousDocsSorted.length; i++) {
      //  https://d1zsuf83nq3j7s.cloudfront.net
      list.push({
        src: `https://d1zsuf83nq3j7s.cloudfront.net/${sousDocsSorted[i]?.chemin}`,
        path: sousDocsSorted[i]?.chemin,
      });
      setImgs([...list]);
      setActiveImg(list[0].src);
      setActiveImgIdx(list[0].path);
    }
    setImageLoaded(true);
    setSelectedSousDocsId(sousDocsSorted[0]._id);
    if (
      document.querySelectorAll(".pageNum")[0]?.style &&
      document.querySelectorAll(".splitted_img")[0]?.style
    ) {
      document.querySelectorAll(".pageNum")[0].style.color = "orange";
      document.querySelectorAll(".splitted_img")[0].style.backgroundColor =
        "#88878729";
    }
  };

  const renderAllImageEmptyOld = async (sousDocs) => {
    // console.log('sous docs in empty : ', sousDocs)
    var sousDocsSorted = [...sousDocs];
    var list = [];
    const token = localStorage.getItem("login_token");
    for (let i = 0; i < sousDocsSorted.length; i++) {
      if (token) {
        let data = await axios.get(
          `${process.env.REACT_APP_HOST_API}/api/documentVO/documentTravail/${sousDocsSorted[i]?._id}`,
          {
            headers: { Authorization: token },
          }
        );

        if (data.status === 200 && data.data?.chemin) {
          // console.log('get img : ', data);
          list.push({
            src: ` https://d1zsuf83nq3j7s.cloudfront.net/${data.data.chemin}`,
            path: data?.data?.chemin,
            id_page: sousDocsSorted[i]?._id,
          });
          setProgress(i + 1);
        } else {
          list.push({
            src: imgs[i].src,
            path: imgs[i].path,
            id_page: sousDocsSorted[i]?._id,
          });
          setProgress(i + 1);
        }
        // console.log('list : ', list)
      } else {
        navigate("/login");
      }
    }
    // console.log('list of empty imgs : ', list)
    setAllErasedImgs([...list]);
  };

  // render all empty image
  const renderAllImageEmpty = async (sousDocs) => {
    // console.log('sous docs in empty : ', sousDocs)
    var sousDocsSorted = [...sousDocs];
    var list = [];
    const token = localStorage.getItem("login_token");
    for (let i = 0; i < sousDocsSorted.length; i++) {
      if (token) {
        let data = await axios.get(
          `${process.env.REACT_APP_HOST_API}/api/documentVO/documentTravail/${sousDocsSorted[i]?._id}`,
          {
            headers: { Authorization: token },
          }
        );

        if (data.status === 200 && data.data?.chemin) {
          // console.log('get img : ', data);
          await axios
            .get(
              `${process.env.REACT_APP_HOST_API}/api/aws/download?url=https://mangas-io-translation.s3.eu-west-3.amazonaws.com/${data.data.chemin}`,
              {
                headers: { Authorization: token },
              }
            )
            .then((res) => {
              if (res.status === 200) {
                list.push({
                  src: `data:image/jpeg;base64,${res.data.file}`,
                  path: data?.data?.chemin,
                  id_page: sousDocsSorted[i]?._id,
                });
                setProgress(i + 1);
              } else {
                toast.error("Something wrong with AWS");
              }
            });
        } else {
          await axios
            .get(
              `${process.env.REACT_APP_HOST_API}/api/aws/download?url=https://mangas-io-translation.s3.eu-west-3.amazonaws.com/${sousDocsSorted[i]?.chemin}`,
              {
                headers: { Authorization: token },
              }
            )
            .then((res) => {
              if (res.status === 200) {
                list.push({
                  src: `data:image/jpeg;base64,${res.data.file}`,
                  path: sousDocsSorted[i]?.chemin,
                  id_page: sousDocsSorted[i]?._id,
                });
                setProgress(i + 1);
              } else {
                toast.error("Something wrong with AWS");
              }
            });
          // list.push({ src: imgs[i].src, path: imgs[i].path, id_page: sousDocsSorted[i]?._id });
          // setProgress(i + 1)
        }
        // console.log('list : ', list)
      } else {
        navigate("/login");
      }
    }
    // console.log('list of empty imgs : ', list)
    setAllErasedImgs([...list]);
  };

  // get empty bubbles img
  const getEmptyBubblesImgs = (selectedImage) => {
    const token = localStorage.getItem("login_token");
    if (token && selectedImage) {
      try {
        axios
          .get(
            `${process.env.REACT_APP_HOST_API}/api/documentVO/documentTravail/${selectedImage?.id_page}`,
            {
              headers: { Authorization: token },
            }
          )
          .then((res) => {
            if (res.status === 200 && res.data?.chemin) {
              console.log("empty imgs : ", res.data);
              setEmptyBubbleImg(
                ` https://d1zsuf83nq3j7s.cloudfront.net/${res.data.chemin}`
              );
            } else {
              setEmptyBubbleImg(null);
            }
          });
      } catch (error) {
        console.log("gommage : ", error);
        toast.error("Error while getting painted page");
      }
    }
  };

  // get empty bubbles images when selected img changes
  useEffect(() => {
    getEmptyBubblesImgs(coordsSelectedImg);
  }, [coordsSelectedImg, transDone, uploadDone, getEmpty]);

  // get all empty bubbles images when selected export pdf
  useEffect(() => {
    if (showExportPdf) {
      renderAllImageEmpty(sousDocs);
    }
  }, [showExportPdf]);

  // get all trans when selected export pdf
  const [originalWandH, setOriginalWandH] = useState([]);
  const imageWidthsRef = useRef([]);
  useEffect(() => {
    const prepareDoc = async () => {
      if (showExportPdf && allErasedImgs?.length !== 0) {
        console.log("get w and h allErasedImgs : ", allErasedImgs);
        // get all translations function
        const getAllTrans = async (imgs) => {
          const token = localStorage.getItem("login_token");
          let list = [];
          if (token) {
            for (let i = 0; i < imgs.length; i++) {
              try {
                let id = imgs[i]?.id_page;
                await axios
                  .get(
                    `${process.env.REACT_APP_HOST_API}/api/translation/get/${id}`,
                    {
                      headers: { Authorization: token },
                    }
                  )
                  .then((res) => {
                    // console.log("get all trans : ", res.data);
                    list.push(res.data);
                  });
              } catch (error) {
                console.log(error);
              }
            }
            console.log("all trans : ", list);
            setAllTrans([...list]);
          }
        };

        const getImageDimensions = async (srcs) => {
          const dimensions = [];

          for (let i = 0; i < srcs.length; i++) {
            const src = srcs[i].src;
            const img = new Image();
            img.crossOrigin = "anonymous"; // Enable CORS for remote images
            img.src = src;

            try {
              // Wait for the image to load
              await new Promise((resolve, reject) => {
                img.onload = () => resolve();
                img.onerror = (err) => reject(err);
              });

              // Get the natural width and height
              dimensions.push({
                o_w: img.naturalWidth,
                o_h: img.naturalHeight,
              });
            } catch (err) {
              console.error("Error loading image:", src, err);
              dimensions.push({ o_w: 0, o_h: 0 }); // Fallback in case of error
            }
          }

          console.log("Image Dimensions:", dimensions);
          return dimensions;
        };

        // Example usage
        const imageWidthsArray = await getImageDimensions(allErasedImgs);
        await getAllTrans(allErasedImgs);
        console.log("imageWidthsArray", imageWidthsArray);
        imageWidthsRef.current = imageWidthsArray;
        setOriginalWandH([...imageWidthsArray]);
      }
    };
    prepareDoc();
  }, [allErasedImgs]);

  // Function to update image dimensions
  const updateImageDimensions = () => {
    const imageElement = document.getElementById("active_img"); // Replace 'myImage' with the ID of your image element
    if (imageElement) {
      // Update image dimensions
      setImageWidth(imageElement.clientWidth);
      setImageHeight(imageElement.clientHeight);
    }
  };
  // get images W and H
  useEffect(() => {
    // Initial call to update image dimensions
    updateImageDimensions();

    // Event listener for window resize
    window.addEventListener("resize", updateImageDimensions);

    // Clean up
    return () => {
      window.removeEventListener("resize", updateImageDimensions);
    };
  }, [showDue, showHideSlide]); // Empty dependency array to run only once on component mount

  // get original W and H
  const handleImageLoad = (event) => {
    updateImageDimensions();
    // Accessing the naturalWidth and naturalHeight properties of the loaded image
    setOriginalWidth(event.target.naturalWidth);
    setOriginalHeight(event.target.naturalHeight);

    // if (coordsSelectedImg?.page_status === "auto") {
    //     setImageLoaded(true);
    //     console.log('img loaded no trans no bubbles')
    // }
    console.log("img loaded with bubbles");
  };

  // close avatar sublist
  // document.addEventListener('click', (e) => {
  //     if (toggleSubList && e.target.id !== 'avatar') {
  //         setToggleSubList(false);
  //     }
  // })

  // update sousDoc
  const updateSousDoc = async (val, id) => {
    const token = localStorage.getItem("login_token");
    if (token) {
      try {
        const res = await axios.put(
          `${process.env.REACT_APP_HOST_API}/api/documentVO/pageStatus/${id}/update`,
          { page_status: val },
          { headers: { Authorization: token } }
        );
        console.log("call updateSousDoc res : ", res);

        if (res.status === 200) {
          console.log("call updateSousDoc status : ", res.status);
          // setPageStatusUpdated(res.data.nom);
          return res.status;
        }
      } catch (error) {
        console.log("updateSousDoc err : ", error);
      }
    } else {
      console.log("No token found");
    }
    return null; // Return null or some default value if the token is missing or there's an error
  };

  // update sousDocTrans
  const updateSousDocTrans = async (val, id) => {
    const token = localStorage.getItem("login_token");
    if (token) {
      try {
        const res = await axios.put(
          `${process.env.REACT_APP_HOST_API}/api/documentVO/pageStatus/${id}/update`,
          { trans_status: val },
          { headers: { Authorization: token } }
        );
        console.log("call updateSousDocTrans res:", res);
        console.log("call this page:", thisPage);

        if (res.status === 200 && thisPage.current === res.data.page) {
          setTransStatusUpdated(res.data.page);
        }
        return res.status;
      } catch (error) {
        console.log("updateSousDocTrans err:", error);
      }
    } else {
      console.log("No token found");
    }
    return null; // Return null or some default value if the token is missing or there's an error
  };

  // update sousDoc
  const updateTomeStatut = async (body, id) => {
    const token = localStorage.getItem("login_token");
    if (token) {
      try {
        const res = await axios.put(
          `${process.env.REACT_APP_HOST_API}/api/tome/${id}/updateTomeStatut`,
          body,
          {
            headers: { Authorization: token },
          }
        );
        console.log("call updateTomeStatut res : ", res);
        return res;
      } catch (error) {
        console.log("call updateTomeStatut err : ", error);
      }
    }
  };

  // when the auto process interrupted
  useEffect(() => {
    const handleBeforeUnload = () => {
      const tomeId = currentTome?.tome?._id; // Ensure you have the correct data here
      const updateData = JSON.stringify({ auto_progress: "interrupted" });

      // Send the API request to save the state or update
      navigator.sendBeacon(
        `${process.env.REACT_APP_HOST_API}/api/tome/${tomeId}/updateStatus`,
        updateData
      );
    };

    // Attach event listener for 'beforeunload' event
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Cleanup when the component is unmounted (to avoid memory leaks)
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [currentTome]);

  // Auto bubble IA
  const autoBubbleIA = async (currentTome, sousDocs) => {
    const token = localStorage.getItem("login_token");
    let docId = currentTome.documentVO._id;
    let sousDocsList = [...sousDocs];
    updateTomeStatut({ auto_progress: "progress" }, currentTome?.tome?._id);
    if (token) {
      console.log("call bubble auto inside : ");
      for (let i = 0; i < sousDocs.length; i++) {
        if (sousDocs[i].page_status === "") {
          try {
            await axios
              .get(
                `${process.env.REACT_APP_HOST_API}/api/documentVO/${docId}/page/${sousDocs[i]._id}/bubbleAI`,
                {
                  headers: { Authorization: token },
                }
              )
              .then(async (res) => {
                if (res.status === 200) {
                  try {
                    let body = {
                      idDocumentVO: sousDocs[i].fk_document_VO,
                      idPage: sousDocs[i]._id,
                    };
                    await axios
                      .post(
                        `${process.env.REACT_APP_HOST_API}/api/translation/translate`,
                        body,
                        {
                          headers: { Authorization: token },
                        }
                      )
                      .then((resp) => {
                        if (resp.status === 200) {
                          updateSousDoc("auto", sousDocs[i]._id);
                          console.log("call bubble auto : ", res.data);
                          sousDocsList[i].page_status = "auto";
                          updateSousDocTrans("done", sousDocs[i]._id);
                          sousDocsList[i].trans_status = "done";
                          console.log("call autoTransAndOCR : ", resp.data);
                        }
                      });
                  } catch (error) {
                    console.log("call autoTransAndOCR err : ", error);
                  }
                  // updateSousDoc("auto", sousDocs[i]._id)
                  // console.log('call bubble auto : ', res.data);
                  // sousDocsList[i].page_status = "auto";
                  // setSousDocs(sousDocsList);
                }
              });
          } catch (error) {
            console.log("call autoBubbleAI err : ", error);
          }
        } else {
          console.log("call bubble auto already");
          // console.log('call bubble auto pageNum ', pageNum);
          // console.log('call bubble coordsSelectedImg ', coordsSelectedImg);
        }
      }
      if (
        currentTome?.tome?._id &&
        currentTome?.tome?.statut_bubble === "" &&
        currentTome?.tome?.statut_trans === ""
      ) {
        updateTomeStatut({ statut_bubble: "done" }, currentTome?.tome?._id);
        updateTomeStatut({ statut_trans: "done" }, currentTome?.tome?._id);
        updateTomeStatut({ auto_progress: "done" }, currentTome?.tome?._id);
        // let newCurrentTome = { ...currentTome };
        // newCurrentTome.tome.statut_bubble = "done";
        // newCurrentTome.tome.statut_trans = "done";
        // newCurrentTome.tome.auto_progress = "done";
        // setCurrentTomePrime({ ...newCurrentTome });
      }
    }
  };

  // auto bubble and trans in the backend
  const sendAutoProcessToServer = async (
    documentVO_id,
    tome_id,
    currentTome
  ) => {
    const token = localStorage.getItem("login_token");
    if ((token && documentVO_id && tome_id, currentTome)) {
      const body = {
        fk_document_VO: documentVO_id,
        tomeId: tome_id,
      };
      let newCurrentTome = { ...currentTome };
      newCurrentTome.tome.auto_progress = "progress";
      setCurrentTomePrime({ ...newCurrentTome });
      try {
        const res = await axios.post(
          `${process.env.REACT_APP_HOST_API}/api/documentVO/runAutoBubble`,
          body,
          {
            headers: { Authorization: token },
          }
        );
        console.log("on server sendAutoProcessToServer res : ", res);
      } catch (error) {
        console.log("on server sendAutoProcessToServer error : ", error);
      }
    }
  };

  // DidMount
  useEffect(() => {
    const token = localStorage.getItem("login_token");
    const user = JSON.parse(localStorage.getItem("login_user"));
    console.log("user : ", user);
    setLoggedUser(user);
    if (!token) {
      navigate("/login");
      setIsLogedIn(false);
    } else {
      setIsLogedIn(true);
      if (currentTome === null) {
        try {
          axios
            .get(`${process.env.REACT_APP_HOST_API}/api/tome/${id}`, {
              headers: { Authorization: token },
            })
            .then((res) => {
              if (res.status === 200) {
                let listSousDocs = res.data.sousDocumentVO.sort(
                  (a, b) => a.page - b.page
                );
                checkValidationOfDoc(res.data.sousDocumentVO);
                setActiveImgIdx(`${res.data.documentVO._id}/001.jpg`);
                setSousDocs([...listSousDocs]);
                setCurrentTome({ ...res.data });
                setCurrentTomePrime({ ...res.data });
                // autoBubbleIA(res.data.documentVO._id, listSousDocs);
                // renderImage(listSousDocs);

                axios
                  .get(
                    `${process.env.REACT_APP_HOST_API}/api/serie/${res.data.tome.fk_serie}`,
                    {
                      headers: { Authorization: token },
                    }
                  )
                  .then(async (resp) => {
                    if (resp.status === 200) {
                      setRelatedSerie(resp.data);
                      await renderImage(listSousDocs);
                      setTimeout(() => {
                        if (
                          document.querySelectorAll(".pageNum")[0]?.style &&
                          document.querySelectorAll(".splitted_img")[0]?.style
                        ) {
                          document.querySelectorAll(".pageNum")[0].style.color =
                            "orange";
                          document.querySelectorAll(
                            ".splitted_img"
                          )[0].style.backgroundColor = "#88878729";
                        }
                      }, 1000);
                      if (res.data.tome.auto_progress === "") {
                        console.log("on server call auto is sent");
                        // await sendAutoProcessToServer(res.data.documentVO._id, res.data.tome._id, res.data);
                      } else {
                        console.log(
                          "on server call is ",
                          res.data.tome.auto_progress
                        );
                      }
                    }
                    // console.log('related serie : ', resp.data);
                    // console.log("current tome : ", res.data);
                    // checkValidationOfDoc(res.data.sousDocumentVO)
                    // setActiveImgIdx(`${res.data.documentVO._id}/001.jpg`)
                    // setCurrentTome({ ...res.data });
                    // setSousDocs([...listSousDocs]);
                  });
              }
            });
        } catch (error) {
          toast.error("Something wrong while getting tomes");
          console.log(error);
        }
      }
    }
  }, []);

  // DidMount to check validation
  useEffect(() => {
    const token = localStorage.getItem("login_token");
    if (!token) {
      navigate("/login");
      setIsLogedIn(false);
    } else {
      try {
        axios
          .get(`${process.env.REACT_APP_HOST_API}/api/tome/${id}`, {
            headers: { Authorization: token },
          })
          .then((res) => {
            if (res.status === 200) {
              checkValidationOfDoc(res.data.sousDocumentVO);
            }
          });
      } catch (error) {
        toast.error("Something wrong while getting tomes");
        console.log(error);
      }
    }
  }, [pageValidated]);

  // get coords from db
  useEffect(() => {
    const token = localStorage.getItem("login_token");
    setCoordsSelectedImg(null);
    // setImageLoaded(false);
    if (token && selectedSousDocsId) {
      try {
        axios
          .get(
            `${process.env.REACT_APP_HOST_API}/api/documentVO/page/${selectedSousDocsId}/zonesDeTexte`,
            {
              headers: { Authorization: token },
            }
          )
          .then((res) => {
            if (res.status === 200) {
              // console.log('coords from db : ', res.data);
              setIaCoords(res.data);
              // console.log('active page atfer delete zone : ', activeImgIdx)
              // console.log('num page atfer delete zone : ', pageNum)
              if (
                (res.data.page_status === "done" &&
                  res.data.sous_images.length === 0) ||
                res.data.trans_status === "done"
              ) {
                setImageLoaded(true);
              }
              setCoordsSelectedImg(res.data);
              thisPage.current = res.data?.page_name;
              setSpots(res.data.sous_images.length);
              setCoordsSelectedImgStored(res.data);
              // if(res.data.trans_status === 'done'){
              //     setImageLoaded(true);
              // }
            }
          });
      } catch (error) {
        toast.error("Something wrong while getting coords");
        console.log("error get coords from db : ", error);
      }
    }
  }, [currentTome, selectedSousDocsId, transStatusUpdated]);

  // validate unvalidate text
  useEffect(() => {
    const token = localStorage.getItem("login_token");
    setCoordsSelectedImgStored(null);
    // setImageLoaded(false);
    if (token && selectedSousDocsId) {
      try {
        axios
          .get(
            `${process.env.REACT_APP_HOST_API}/api/documentVO/page/${selectedSousDocsId}/zonesDeTexte`,
            {
              headers: { Authorization: token },
            }
          )
          .then((res) => {
            if (res.status === 200) {
              // console.log('coords from db : ', res.data);
              setIaCoords(res.data);
              // console.log('active page atfer delete zone : ', activeImgIdx)
              // console.log('num page atfer delete zone : ', pageNum)
              if (
                (res.data.page_status === "done" &&
                  res.data.sous_images.length === 0) ||
                res.data.trans_status === "done"
              ) {
                setImageLoaded(true);
              }
              setCoordsSelectedImgStored({ ...res.data });
              thisPage.current = res.data?.page_name;
              setSpots(res.data.sous_images.length);
              // if(res.data.trans_status === 'done'){
              //     setImageLoaded(true);
              // }
            }
          });
      } catch (error) {
        toast.error("Something wrong while getting coords");
        console.log("error get coords from db : ", error);
      }
    }
  }, [selectedSousDocsId, allTextsValid]);

  // get translation
  useEffect(() => {
    const token = localStorage.getItem("login_token");
    setSelectedTrans({});
    if (token && coordsSelectedImg?.trans_status === "trans") {
      setHasTrans("loading");
      try {
        axios
          .get(
            `${process.env.REACT_APP_HOST_API}/api/translation/get/${coordsSelectedImg.id_page}`,
            {
              headers: { Authorization: token },
            }
          )
          .then((res) => {
            // console.log('res data in get translation useEffect : ', res.data)

            if (res.status === 200 && res.data.length !== 0) {
              // setTranslation([...translation, res.data]);
              setHasTrans(true);
              // setTextIsUpdated(res.data)
              setSelectedTrans(res.data);
              setSelectedTransTwo(res.data);
              checkValidationOfTexts(res.data.sous_images);
              setImageLoaded(true);
              // console.log('translation from db : ', res.data);
            } else {
              setHasTrans(false);
              setEmptyBubbleImg(null);
              setSelectedTrans(null);
              setSelectedTransTwo(null);
            }
          });
      } catch (error) {
        toast.error("Something wrong while getting translation");
        console.log("error get translation from db : ", error);
      }
    }
  }, [
    coordsSelectedImg,
    transDone,
    getTrans,
    textIsUpdated,
    fontsDefault,
    isForceValidationDone,
  ]);

  // get trans when update w | h | x | y of spote
  useEffect(() => {
    const token = localStorage.getItem("login_token");
    if (token && getNow) {
      setPreviewExportReady(false);
      try {
        axios
          .get(
            `${process.env.REACT_APP_HOST_API}/api/translation/get/${coordsSelectedImg.id_page}`,
            {
              headers: { Authorization: token },
            }
          )
          .then((res) => {
            console.log(
              "res update data in get translation useEffect when update spots : ",
              res.data
            );
            if (res.status === 200 && res.data.length !== 0) {
              setSelectedTransTwo(res.data);
              setPreviewExportReady(true);
            } else {
              setSelectedTransTwo(null);
              setPreviewExportReady(false);
            }
          });
      } catch (error) {
        setPreviewExportReady(false);
        toast.error("Error while getting translation when update spote");
        console.log("error get translation from db : ", error);
      }
    }
  }, [getNow]);

  // console.log('trans : ', selectedTrans);
  // console.log("translated page : ", selectedTrans, " and selected page", coordsSelectedImg)

  // console.log("imgs : ", imgs)
  // call IA to detect bubbles
  const detectBubblesHandler = async (id) => {
    console.log("detectBubblesHandler");
    setGetCoords("Waiting...");
    const token = localStorage.getItem("login_token");
    if (token) {
      try {
        await axios
          .get(
            `${process.env.REACT_APP_HOST_API}/api/documentVO/${currentTome.documentVO._id}/page/${id}/bubbleAI`,
            {
              headers: { Authorization: token },
            }
          )
          .then(async (res) => {
            // setGetCoords('Bubble AI');
            if (res.status === 200) {
              // setIaCoords(res.data);
              // setCoordsSelectedImg(res.data)
              let selected = { ...coordsSelectedImg };
              let updated = await updateSousDoc("done", id);
              console.log("updated : ", updated);
              if (updated === 200) {
                setGetCoords("Bubble AI");
                selected.page_status = "done";
                setCoordsSelectedImg(selected);
                setCoordsSelectedImgStored(selected);
              } else {
                toast.error("Something wrong with Bubble AI");
              }
              // console.log('coords : ', res.data)
            }
          });
      } catch (error) {
        toast.error("Something wrong with Bubble AI");
        console.log(error);
      }
    }
  };

  const detectBubbles = async (id) => {
    if (
      coordsSelectedImg.sous_images.length !== 0 &&
      coordsSelectedImg.page_status === "auto"
    ) {
      let selected = { ...coordsSelectedImg };
      setGetCoords("Waiting...");
      let updated = await updateSousDoc("done", id);
      console.log("updated page Status on click : ", updated);
      if (updated === 200) {
        setGetCoords("Bubble AI");
        selected.page_status = "done";
        setCoordsSelectedImg(selected);
        setCoordsSelectedImgStored(selected);
        pageStatus("b");
      }
    } else {
      detectBubblesHandler(id);
    }
  };

  // translation
  // const translateBubbles = () => {
  //     setIsTranslated('Please Wait...');
  //     setGetEmpty({});
  //     const token = localStorage.getItem("login_token");
  //     if (token) {
  //         let body = {
  //             "idDocumentVO": coordsSelectedImg.id_parent,
  //             "idPage": coordsSelectedImg.id_page
  //         };
  //         console.log('body translate : ', body)
  //         try {
  //             axios.post(`${process.env.REACT_APP_HOST_API}/api/translation/translate`, body,
  //                 {
  //                     headers: { 'Authorization': token }
  //                 }).then(resp => {
  //                     if (resp.status === 200) {
  //                         console.log('translation at first : ', resp.data)
  //                         // setGetTrans(resp.data);
  //                         try {
  //                             axios.post(`${process.env.REACT_APP_HOST_API}/api/translation/paint`, body,
  //                                 {
  //                                     headers: { 'Authorization': token }
  //                                 }).then(async (res) => {
  //                                     if (res.status === 200) {
  //                                         let selected = { ...coordsSelectedImg }
  //                                         setGetEmpty(res.data);
  //                                         setGetTrans(resp.data);
  //                                         setTransDone(true)
  //                                         let updated = await updateSousDoc("trans", coordsSelectedImg.id_page);
  //                                         if (updated.status === 200) {
  //                                             selected.page_status = "trans";
  //                                             setCoordsSelectedImg(selected);
  //                                             setIsTranslated('Translation AI')
  //                                         }

  //                                     }
  //                                 })
  //                         } catch (error) {
  //                             if (error.response.status === 400 || error.response.status === 500) {
  //                                 toast.error('AI not availible ( paint )');
  //                             }
  //                         }
  //                     }
  //                 })
  //         } catch (error) {
  //             if (error.response.status === 400 || error.response.status === 500) {
  //                 toast.error('AI not availible ( translation )');
  //             }
  //         }
  //     }
  // }
  const translateBubbles = () => {
    setIsTranslated("Please Wait...");
    setGetEmpty({});
    const token = localStorage.getItem("login_token");
    if (token && coordsSelectedImg.trans_status === "done") {
      if (!currentTome?.tome?.isLayered) {
        let body = {
          idDocumentVO: coordsSelectedImg.id_parent,
          idPage: coordsSelectedImg.id_page,
        };
        console.log("body translate : ", body);
        try {
          axios
            .post(
              `${process.env.REACT_APP_HOST_API}/api/translation/paint`,
              body,
              {
                headers: { Authorization: token },
              }
            )
            .then(async (res) => {
              if (res.status === 200) {
                let selected = { ...coordsSelectedImg };
                setGetEmpty(res.data);
                setGetTrans(res.data);
                setTransDone(true);
                let updated = await updateSousDocTrans(
                  "trans",
                  coordsSelectedImg.id_page
                );
                if (updated === 200) {
                  selected.trans_status = "trans";
                  setCoordsSelectedImg({ ...selected });
                  [...document.querySelectorAll(".spote")].map((el) => {
                    el.style.display = "flex";
                  });
                  setIsTranslated("Translation AI");
                  pageStatus("t");
                }
              }
            });
        } catch (error) {
          toast.error("AI not availible ( paint )");
        }
      } else {
        try {
          let body = {
            pdf_id: currentTome?.documentVO?._id,
            path_pdf: currentTome?.documentVO?.chemin,
            page_num: pageNum - 1,
            fk_sousDocument_VO: coordsSelectedImg?.id_page,
          };

          axios
            .post(
              `${process.env.REACT_APP_HOST_API}/api/translation/pait_layered`,
              body,
              {
                headers: { Authorization: token },
              }
            )
            .then(async (res) => {
              if (res.status === 200) {
                console.log("layered paint res :", res);
                let selected = { ...coordsSelectedImg };
                setGetEmpty(res.data);
                setGetTrans(res.data);
                setTransDone(true);
                let updated = await updateSousDocTrans(
                  "trans",
                  coordsSelectedImg.id_page
                );
                if (updated === 200) {
                  selected.trans_status = "trans";
                  setCoordsSelectedImg({ ...selected });
                  [...document.querySelectorAll(".spote")].map((el) => {
                    el.style.display = "flex";
                  });
                  setIsTranslated("Translation AI");
                  pageStatus("t");
                }
              }
            });
        } catch (error) {
          toast.error("Error while getting paited page");
        }
      }
    }
  };

  //delete zone
  const deleteZone = async (zone, i) => {
    // console.log('delete this zone : ', zone);
    const token = localStorage.getItem("login_token");
    if (token) {
      try {
        await axios
          .delete(
            `${process.env.REACT_APP_HOST_API}/api/documentVO/zonesDeTexte/${zone._id}`,
            {
              headers: { Authorization: token },
            }
          )
          .then((res) => {
            // console.log('delete zone status ', res.status);
            if (res.status === 200) {
              document.getElementById(`${zone._id}`).style.display = "none";
              document.getElementById(`ref-${zone._id}`).style.display = "none";
              document.getElementById(`spote-${i}`).style.display = "none";
              setSpots((prev) => prev - 1);
            }
          });
      } catch (error) {
        if (error.response.status === 400 || error.response.status === 500) {
          toast.error("Something wrong while deleting this spot");
        }
        console.log("delete zone de text : ", error);
      }
    }
  };
  // console.log('delete zone is ', zoneRemoved);
  // console.log('sousDocs : ', sousDocs)
  // console.log('active path def : ', activeImgIdx);
  console.log("current tome : ", currentTome);
  // show hide sub list
  const [toggleSubList, setToggleSubList] = useState(false);
  const showHideSubList = () => {
    setToggleSubList(!toggleSubList);
  };

  // show slide
  const showAndHideSlide = () => {
    // console.log('before ', showHideSlide);
    setShowHideSlide(!showHideSlide);
    if (coordsUpdated !== null) {
      setGetNow(Math.random());
      setCoordsUpdated(null);
    }
    // console.log('after ', showHideSlide);
  };

  console.log(
    `IMAGE W : ${imageWidth} & H : ${imageHeight} but OW : ${originalWidth} and OH : ${originalHeight}`
  );
  console.log("selected coords : ", coordsSelectedImg);

  const downloadFile = () => {
    console.log(document.getElementById("downloadThisImage"));
    document.getElementById("downloadThisImage").click();
  };

  const openImportFile = () => {
    document.getElementById("importFile").click();
  };

  const closeImportFile = () => {
    setOpenImportedFile(false);
    setFileToImport(null);
  };

  const importFileHandler = (event) => {
    const file = event.target?.files[0];
    if (file) {
      console.log(file);
      setFileToImport(file);
      setOpenImportedFile(true);
    } else {
      console.log("no file");
      setOpenImportedFile(false);
    }
  };

  const importThisFile = async () => {
    console.log("file name : ", fileToImport.name);
    let formData = new FormData();
    formData.append("file", fileToImport);
    const token = localStorage.getItem("login_token");
    if (token) {
      setIsUploaded(true);
      try {
        await axios
          .put(
            `${process.env.REACT_APP_HOST_API}/api/aws/${coordsSelectedImg.id_page}`,
            formData,
            {
              headers: { Authorization: token },
            }
          )
          .then((res) => {
            console.log("res of import file : ", res);
            if (res.status === 200) {
              setIsUploaded(false);
              // setUploadDone(`${Math.random()}`)
              setEmptyBubbleImg(
                ` https://d1zsuf83nq3j7s.cloudfront.net/${res.data}`
              );
              setFileToImport(null);
              closeImportFile();
            }
          })
          .catch((err) => console.log("error of import file : ", err));
      } catch (error) {
        if (error.response.status === 400 || error.response.status === 500) {
          toast.error("Something wrong while importing file");
        }
        console.log("import page error : ", error);
      }
    }
  };

  const textUpdated = (data) => {
    console.log("text is updated ...");
    setTextIsUpdated(data);
  };

  const showDueHandler = () => {
    setShowDue(!showDue);
    if (coordsUpdated !== null) {
      setGetNow(Math.random());
      setCoordsUpdated(null);
    }
    console.log("show due : ", showDue);
    console.log("show Slide : ", showHideSlide);
    if ((!showDue && !showHideSlide) || (!showDue && showHideSlide)) {
      setShowHideSlide(false);
    } else if ((showDue && !showHideSlide) || (showDue && showHideSlide)) {
      setShowHideSlide(true);
    }
  };

  const exportListHandler = () => {
    setExportList(!exportList);
  };

  // document.addEventListener('click', (e) => {
  //     // console.log('clicked : ', e.target.id)
  //     if (exportList === true && e.target.id !== "change" && e.target.id !== "change_text") {
  //         setExportList(false);
  //     }
  // })

  const showVOImage = () => {
    setShowVO(!showVO);
    if (coordsUpdated !== null) {
      setGetNow(Math.random());
      setCoordsUpdated(null);
    }
  };

  const showExportHandler = () => {
    setShowExportPdf(!showExportPdf);
  };

  const handleDownloadPDFOLD = () => {
    setShowProgress(true);
    const images = [...document.querySelectorAll(".active_img_export")];
    console.log("export images : ", images);
    console.log("export all painted images : ", allErasedImgs);
    let pdf = new jsPDF("p", "px", "a4", true);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const margin = 10;
    const availableWidth = pdfWidth - 2 * margin;
    const availableHeight = pdfHeight - 2 * margin;

    for (let i = 0; i < images.length; i++) {
      html2canvas(images[i], { useCORS: true }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const ratio = Math.min(
          availableWidth / imgWidth,
          availableHeight / imgHeight
        );
        const imgX = margin + (availableWidth - imgWidth * ratio) / 2;
        const imgY = margin + (availableHeight - imgHeight * ratio) / 2;
        console.log("export images imgData : ", imgData);
        // Add image to PDF

        pdf.addImage(
          imgData,
          "PNG",
          imgX,
          imgY,
          imgWidth * ratio,
          imgHeight * ratio
        );

        if (i < images.length - 1) {
          pdf.addPage();
        }
        // If all images have been processed, save the PDF
        if (i === images.length - 1) {
          console.log("export images pdf : ", pdf);
          pdf.save(`${currentTome.tome.nom}.pdf`);
          setShowProgress(false);
        }
      });
    }
  };

  const handleDownloadPDF = async () => {
    setShowProgress(true);
    document.body.style.overflow = "hidden";
    const images = [...document.querySelectorAll(".active_img_export")];
    console.log("export images : ", images);
    console.log("export all painted images : ", allErasedImgs);

    let pdf = new jsPDF("p", "px", "a4", true);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const margin = 10;
    const availableWidth = pdfWidth - 2 * margin;
    const availableHeight = pdfHeight - 2 * margin;

    try {
      for (let i = 0; i < images.length; i++) {
        // Update the current page being processed
        setCurrentPage(i + 1);

        const img = images[i];
        const canvas = await domtoimage.toCanvas(img, {
          useCORS: true,
          allowTaint: true,
          logging: true,
        });

        const imgData = canvas.toDataURL("image/png");
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const ratio = Math.min(
          availableWidth / imgWidth,
          availableHeight / imgHeight
        );
        const imgX = margin + (availableWidth - imgWidth * ratio) / 2;
        const imgY = margin + (availableHeight - imgHeight * ratio) / 2;

        pdf.addImage(
          imgData,
          "PNG",
          imgX,
          imgY,
          imgWidth * ratio,
          imgHeight * ratio
        );

        if (i < images.length - 1) {
          pdf.addPage();
        }
      }

      console.log("export images pdf : ", pdf);
      pdf.save(`${currentTome.tome.nom}.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      document.body.style.overflow = "auto";
      setShowProgress(false);
      setCurrentPage(0); // Reset current page after processing
    }
  };

  const handleDownloadPDFNot = async () => {
    setShowProgress(true);
    document.body.style.overflow = "hidden";
    const images = [...document.querySelectorAll(".active_img_export")];
    console.log("Export images:", images);
    console.log("Export all painted images:", allErasedImgs);

    let pdf = new jsPDF("p", "px", "a4", true);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();
    const margin = 10;
    const availableWidth = pdfWidth - 2 * margin;
    const availableHeight = pdfHeight - 2 * margin;

    const getBase64Image = async (imgUrl) => {
      try {
        const response = await fetch(`${imgUrl}`, {
          mode: "cors", // Allow cross-origin requests
          credentials: "omit", // Don't send cookies
          referrerPolicy: "no-referrer", // Prevent CORS blocking
        });
        const blob = await response.blob();
        const base64 = Buffer.from(await blob.arrayBuffer()).toString("base64");
        console.log("export fetching image base64:", base64);
        return base64;
      } catch (error) {
        console.error("Error fetching image:", error);
        return null;
      }
    };

    try {
      for (let i = 0; i < allErasedImgs.length; i++) {
        setCurrentPage(i + 1);

        const img = allErasedImgs[i];
        const imgUrl = img.src; // Get image URL from the DOM
        const base64 = await getBase64Image(imgUrl);

        if (base64) {
          const imgWidth = img.width;
          const imgHeight = img.height;
          const ratio = Math.min(
            availableWidth / imgWidth,
            availableHeight / imgHeight
          );
          const imgX = margin + (availableWidth - imgWidth * ratio) / 2;
          const imgY = margin + (availableHeight - imgHeight * ratio) / 2;

          pdf.addImage(
            base64,
            "JPEG",
            imgX,
            imgY,
            imgWidth * ratio,
            imgHeight * ratio
          );
        }

        if (i < images.length - 1) {
          pdf.addPage();
        }
      }

      console.log("Export images PDF:", pdf);
      pdf.save(`${currentTome.tome.nom}.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      document.body.style.overflow = "auto";
      setShowProgress(false);
      setCurrentPage(0);
    }
  };

  // const handleDownloadPDF = async () => {
  //     setShowProgress(true); // Show progress indicator

  //     try {
  //         // Select all image elements inside active_img_export divs
  //         const images = [...document.querySelectorAll('.active_img_export img')];
  //         console.log('Images found:', images);

  //         // Ensure all images are loaded before processing
  //         const loadImage = (img) =>
  //             new Promise((resolve, reject) => {
  //                 if (img.complete && img.naturalWidth > 0) {
  //                     resolve(img);
  //                 } else {
  //                     img.onload = () => resolve(img);
  //                     img.onerror = () => reject(new Error(`Failed to load image: ${img.src}`));
  //                 }
  //             });

  //         await Promise.all(images.map(loadImage));

  //         // Initialize the PDF
  //         const pdf = new jsPDF('p', 'px', 'a4', true);
  //         const pdfWidth = pdf.internal.pageSize.getWidth();
  //         const pdfHeight = pdf.internal.pageSize.getHeight();
  //         const margin = 10; // Margin around the image
  //         const availableWidth = pdfWidth - 2 * margin;
  //         const availableHeight = pdfHeight - 2 * margin;

  //         for (let i = 0; i < images.length; i++) {
  //             const img = images[i];

  //             // Render the image itself into a canvas
  //             const canvas = document.createElement('canvas');
  //             const ctx = canvas.getContext('2d');
  //             canvas.width = img.naturalWidth;
  //             canvas.height = img.naturalHeight;
  //             ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

  //             // Convert the canvas to a data URL
  //             const imgData = canvas.toDataURL('image/png');

  //             // Calculate dimensions to fit within the PDF page
  //             const ratio = Math.min(availableWidth / canvas.width, availableHeight / canvas.height);
  //             const imgWidth = canvas.width * ratio;
  //             const imgHeight = canvas.height * ratio;
  //             const imgX = margin + (availableWidth - imgWidth) / 2;
  //             const imgY = margin + (availableHeight - imgHeight) / 2;

  //             // Add the image to the PDF
  //             pdf.addImage(imgData, 'PNG', imgX, imgY, imgWidth, imgHeight);

  //             // Add a new page if not the last image
  //             if (i < images.length - 1) {
  //                 pdf.addPage();
  //             }
  //         }

  //         // Save the PDF
  //         pdf.save('images.pdf');
  //     } catch (error) {
  //         console.error('Error generating PDF:', error);
  //     } finally {
  //         setShowProgress(false); // Hide progress indicator
  //     }
  // };

  const validateThisPage = () => {
    setValidationText("Please wait...");
    console.log(selectedTrans);
    let id_page = coordsSelectedImg.id_page;
    const token = localStorage.getItem("login_token");
    console.log("token : ", token, "id page : ", id_page);
    if (token) {
      try {
        axios
          .put(
            `${process.env.REACT_APP_HOST_API}/api/documentVO/pageValidation/${id_page}`,
            {},
            {
              headers: { Authorization: token },
            }
          )
          .then((res) => {
            console.log("res of validate page : ", res);
            if (res.status === 200) {
              console.log("validated : ", res);
              setPageValidated(res.data);
              setValidationText("Skip detection");
              setValidationPage(true);
              if (selectedTrans?.sous_images) {
                checkValidationOfTexts(selectedTrans.sous_images);
              }
              skipAndValidate();
            }
          });
      } catch (error) {
        if (error.response.status === 400 || error.response.status === 500) {
          toast.error("Something wrong while validating text");
        }
        console.log("validate page error : ", error);
      }
    }
  };

  // document.querySelectorAll('img').forEach(img => {
  //     img.addEventListener('dragstart', (e) => {
  //         e.preventDefault();
  //     });
  // });

  // socket get all users
  useEffect(() => {
    if (loggedUser?.id && currentTome?.tome) {
      socket.emit("userConnected", loggedUser?.id, currentTome?.tome?._id);

      socket.on("users", (users) => {
        setUsersActive([...users]);
      });
    }

    return () => {
      // socket.emit('userConnectedOut', loggedUser?.id, "out");
      socket.off("users");
    };
  }, [loggedUser, currentTome]);

  // online users
  useEffect(() => {
    if (usersActive?.length && group?.length) {
      let result = getMatchingElements(usersActive, group);
      let newResult = result.filter(
        (el) =>
          el._id !== loggedUser.id &&
          el?.online &&
          el.location === currentTome?.tome?._id
      );
      setUsersOnline(newResult);
    }
  }, [usersActive, group]);

  // trans progress socket
  useEffect(() => {
    if (currentTome && coordsSelectedImg) {
      socket.on("trans_progress", (data) => {
        console.log("Received trans progress:", data);
        if (data?.message) {
          let newCurrentTome = { ...currentTome };
          newCurrentTome.tome.trans_progress = "done";
          let selected = { ...coordsSelectedImg };
          selected.trans_status = "trans";
          setCoordsSelectedImg(selected);
          setCurrentTomePrime({ ...newCurrentTome });
          setTransAll({ val: 0 });
        }
      });
    }

    // Cleanup listener on unmount
    return () => {
      socket.off("trans_progress");
    };
  }, [currentTome, coordsSelectedImg]);

  // auto process socket
  useEffect(() => {
    if (currentTome && coordsSelectedImg) {
      // when trans done
      socket.on("auto_process", (data) => {
        console.log("Received auto process:", data);
        if (data?.message) {
          let newCurrentTome = { ...currentTome };
          newCurrentTome.tome.statut_bubble = "done";
          newCurrentTome.tome.statut_trans = "done";
          newCurrentTome.tome.auto_progress = "done";
          let selected = { ...coordsSelectedImg };
          selected.page_status = "auto";
          setCoordsSelectedImg({ ...selected });
          setCurrentTomePrime({ ...newCurrentTome });
          setBubbleAll({ val: 0 });
        }
      });
      // when each page passed auto
      socket.on("page_ready_auto", (data) => {
        console.log("on server page_ready_auto : ", data);
        setPageNumReady(parseInt(data.page_num.split(".")[0]));
        if (data.page_num === thisPage.current) {
          setTransStatusUpdated(data.page_num);
        }
      });
      //when all progress done
      socket.on("all_pages_done", (data) => {
        console.log("on server all_pages_done : ", data);
        if (data.success) {
          let newCurrentTome = { ...currentTome };
          newCurrentTome.tome.auto_progress = "done";
          setCurrentTomePrime({ ...newCurrentTome });
        }
      });
    }

    // Cleanup listener on unmount
    return () => {
      socket.off("auto_process");
      socket.off("page_ready_auto");
    };
  }, [currentTome, coordsSelectedImg]);

  // auto read notifs
  const updateNotifsWhenOpen = async (notifications) => {
    const token = localStorage.getItem("login_token");
    if (token) {
      for (let i = 0; i < notifications.length; i++) {
        if (notifications[i].statut === "sent") {
          try {
            await axios
              .put(
                `${process.env.REACT_APP_HOST_API}/api/notification/update_statut/${notifications[i]._id}`,
                {},
                {
                  headers: { Authorization: token },
                }
              )
              .then((res) => {
                console.log("res update notifs to seen : ", res);
                if (res.status === 200) {
                  setNewNotifications([]);
                }
              });
          } catch (error) {
            console.log("update notif to seen err : ", error);
          }
        }
      }
    }
  };

  useEffect(() => {
    if (toggleNotif === true && notifications.length !== 0) {
      updateNotifsWhenOpen(notifications);
      setNewNotifications([]);
    }
  }, [toggleNotif]);

  // show notifications start
  const showHideNotif = () => {
    setToggleNotif(!toggleNotif);
  };

  // document.addEventListener('click', (e) => {
  //     let el = e.target.id || e.target.parentElement?.id;
  //     if (el !== "notif") {
  //         setToggleNotif(false);
  //     }
  // })
  // show notifications end

  // socket get notifs
  useEffect(() => {
    if (relatedSerie?._id) {
      socket.on("notification", (list) => {
        let newList = list.filter((el) => el.target_user === loggedUser.id);
        setNewNotifications([...newList]);
        setNotifications([...notifications, ...newList]);
      });
    }

    return () => {
      socket.off("notification");
    };
  }, [loggedUser?.id, relatedSerie]);

  const defaultPoliceChange = (e) => {
    if (e.target.name === "stroke_color") {
      let newvalue = e.target.value;
      const r = parseInt(newvalue.substring(1, 3), 16);
      const g = parseInt(newvalue.substring(3, 5), 16);
      const b = parseInt(newvalue.substring(5, 7), 16);
      let newPolice = { ...defaultPolice, [e.target.name]: `${r}, ${g}, ${b}` };
      console.log("newPolice : ", newPolice);
      setDefaultPolice({ ...newPolice });
    } else {
      let newPolice = { ...defaultPolice, [e.target.name]: e.target.value };
      console.log("newPolice : ", newPolice);
      setDefaultPolice({ ...newPolice });
    }
  };

  const defaultPoliceChangeOpacity = (e) => {
    let newPolice = { ...defaultPolice };
    let newvalue = e.target.value;
    newPolice.stroke_opacity = newvalue;
    console.log("newPolice : ", newPolice);
    setDefaultPolice({ ...newPolice });
  };

  const onOffShadow = (stroke_applied) => {
    let newPolice = { ...defaultPolice };
    newPolice.stroke_applied = !stroke_applied;
    console.log("newPolice : ", newPolice);
    setDefaultPolice({ ...newPolice });
  };

  function rgbToHex(rgbString) {
    console.log("rgbToHex : ", rgbString);
    const [r, g, b] = rgbString
      .split(",")
      .map((num) => parseInt(num.trim(), 10));
    const hexColor = `#${((1 << 24) | (r << 16) | (g << 8) | b)
      .toString(16)
      .slice(1)
      .toUpperCase()}`;
    console.log("rgbhexColor ", hexColor);
    return hexColor;
  }

  const validateDefaultPolice = async () => {
    const token = localStorage.getItem("login_token");
    if (token && currentTome?.tome?._id && defaultPolice) {
      let body = defaultPolice;
      console.log("default police ", body);
      try {
        await axios
          .put(
            `${process.env.REACT_APP_HOST_API}/api/translation/defaultPolice/${currentTome.tome._id}/update`,
            body,
            {
              headers: { Authorization: token },
            }
          )
          .then((res) => {
            if (res.status === 200) {
              console.log("police sent res ,", res);
              toast.success("default text style is applayed successfully");
              setFontsDefault(res.data);
            }
          });
      } catch (error) {
        toast.error("Error while sending default font style");
      }
    }
    console.log("newPolice confirm : ", defaultPolice);
  };

  // re-get sousDocs when apply bubble to all doc
  useEffect(() => {
    const token = localStorage.getItem("login_token");
    const user = JSON.parse(localStorage.getItem("login_user"));
    console.log("user : ", user);
    setLoggedUser(user);
    if (!token) {
      navigate("/login");
      setIsLogedIn(false);
    } else {
      setIsLogedIn(true);
      try {
        axios
          .get(`${process.env.REACT_APP_HOST_API}/api/tome/${id}`, {
            headers: { Authorization: token },
          })
          .then((res) => {
            if (res.status === 200) {
              let listSousDocs = res.data.sousDocumentVO.sort(
                (a, b) => a.page - b.page
              );
              setSousDocs([...listSousDocs]);
              // setCoordsSelectedImgStored(selected);
            }
          });
      } catch (error) {
        toast.error("Something wrong while re-getting sousDocs");
        console.log(error);
      }
    }
  }, [bubbleAll?.val, transAll?.val, isForceValidationDone]);

  const applyBubbleOnDoc = async () => {
    console.log("clicked applyBubbleOnDoc");
    const token = localStorage.getItem("login_token");
    if (token && currentTome?.tome?._id) {
      setBubbleAllSpin(true);
      try {
        await axios
          .put(
            `${process.env.REACT_APP_HOST_API}/api/tome/applyBubbleAI/${currentTome.tome._id}`,
            {},
            {
              headers: { Authorization: token },
            }
          )
          .then((res) => {
            if (res.status === 200) {
              setBubbleAll({ val: true });
              let selected = { ...coordsSelectedImg };
              selected.page_status = "done";
              let newCurrentTome = { ...currentTomePrime };
              newCurrentTome.tome.apply_bubble = true;
              setCoordsSelectedImg(selected);
              setCurrentTomePrime(newCurrentTome);
              setBubbleAllSpin(false);
            }
            console.log("applyBubbleOnDoc : ", res.data);
          });
      } catch (error) {
        toast.warning("Operation timed out. Please try again later.");
      }
    }
  };

  const applyTransOnDoc = async () => {
    console.log("clicked applyTransOnDoc");
    const token = localStorage.getItem("login_token");
    if (token && currentTome?.tome?._id) {
      setTransAllSpin(true);
      if (currentTome?.tome?.isLayered) {
        console.log("call apply all trans layered");
        try {
          axios
            .put(
              `${process.env.REACT_APP_HOST_API}/api/tome/applyTransAI/${currentTome.tome._id}`,
              {},
              {
                headers: { Authorization: token },
              }
            )
            .then((res2) => {
              console.log("apply all trans : ", res2.data);
              if (res2.status === 200) {
                setTransAll({ val: true });
                let selected = { ...coordsSelectedImg };
                selected.trans_status = "trans";
                let newCurrentTome = { ...currentTomePrime };
                newCurrentTome.tome.apply_trans = true;
                setCoordsSelectedImg(selected);
                setCurrentTomePrime(newCurrentTome);
                setTransAllSpin(false);
              }
            });
        } catch (error) {
          toast.warning("Operation timed out. Please try again later.");
        }
      } else {
        // turn on EC2 first (optional, continues even if it fails)
        try {
          const startEC2 = await axios.post(
            `${process.env.REACT_APP_HOST_API}/api/translation/start_ec2`,
            { tomeId: currentTome?.tome?._id },
            {
              headers: { Authorization: token },
            }
          );
          console.log("apply all trans : start ec2 res :", startEC2.data);
        } catch (ec2Error) {
          console.log("EC2 start not available, continuing without it:", ec2Error);
        }
        
        // Continue with translation regardless of EC2 status
        try {
          const applyTrans = await axios.put(
            `${process.env.REACT_APP_HOST_API}/api/tome/applyTransAI/${currentTome.tome._id}`,
            {},
            {
              headers: { Authorization: token },
            }
          );
          console.log("apply all trans : ", applyTrans.data);
          if (applyTrans.status === 200) {
            setTransAll({ val: true });
            let selected = { ...coordsSelectedImg };
            selected.trans_status = "trans";
            setCoordsSelectedImg(selected);
            setTransAllSpin(false);
          }
        } catch (error) {
          toast.warning("Operation timed out. Please try again later.");
        } finally {
          // Try to stop EC2 if it was started
          try {
            const stopEC2 = await axios.post(
              `${process.env.REACT_APP_HOST_API}/api/translation/stop_ec2`,
              {},
              {
                headers: { Authorization: token },
              }
            );
            console.log("apply all trans : stop ec2 res :", stopEC2.data);
          } catch (error) {
            console.log("stopping EC2 err (ignored):", error);
          }
        }
      }
    }
  };

  const showVlidationIcon = () => {
    const updatedList = sousDocs.map((page) => ({
      ...page,
      validation: true,
    }));

    setSousDocs([...updatedList]);
  };

  const forceValidateAllTome = async () => {
    console.log("clicked forceValidateAllTome");
    setIsForceValidation(true);

    const token = localStorage.getItem("login_token");
    if (token) {
      try {
        const res = await axios.put(
          `${process.env.REACT_APP_HOST_API}/api/tome/force-validate-tome/${coordsSelectedImg?.id_parent}/${id}`,
          {},
          { headers: { Authorization: token } }
        );

        console.log("force validation : ", res.data);
        let newCoordSelectedImg = { ...coordsSelectedImgStored };
        newCoordSelectedImg.validation = true;
        setCoordsSelectedImgStored({ ...newCoordSelectedImg });
        setAllSousDocsValid(true);
        showVlidationIcon();
        toast.success("All the tome has been validated");
      } catch (error) {
        console.log("force validation err : ", error);
        toast.error("Error while force validating");
      } finally {
        setTimeout(() => setIsForceValidation(false), 500);
        setIsForceValidationDone(`${Math.random()}`);
      }
    } else {
      setIsForceValidation(false);
      toast.error("Invalid token");
    }
  };

  const showPreviewExport = () => {
    setPreviewExport((prev) => !prev);
    if (!previewExport) {
      setGetNow(Math.random());
    }
  };

  // console.log('notifications : ', notifications)
  // console.log('newNotifications : ', newNotifications);

  console.log("activeImg : ", activeImg);
  console.log("relatedSerie : ", relatedSerie);
  console.log("selectedTrans : ", selectedTrans);
  console.log("sousDocs : ", sousDocs);
  console.log("hasTrans : ", hasTrans);
  console.log("numPage : ", pageNum);
  console.log("coordSelectedImg : ", coordsSelectedImg);
  console.log("this page : ", thisPage);
  console.log("defaultPolice : ", defaultPolice);
  console.log("transAll : ", transAll);
  console.log("users online : ", usersOnline);
  console.log("currentTomePrime : ", currentTomePrime);
  console.log("allWidths:", originalWandH);

  if (isLogedin) {
    return (
      <>
        <div className="edition_container">
          <div className="edition_header">
            {currentTomePrime?.tome?.auto_progress === "progress" && (
              <div className="ai_on_doc">
                <span className="spinning">
                  <AiOutlineLoading3Quarters />
                </span>{" "}
                Auto process in running{" "}
                {pageNumReady !== "" ? pageNumReady : "..."} /{" "}
                {sousDocs?.length}
              </div>
            )}
            {bubbleAllSpin && (
              <div className="ai_on_doc">
                <span className="spinning">
                  <AiOutlineLoading3Quarters />
                </span>{" "}
                Bubble IA is applied, please wait...
              </div>
            )}
            {(transAllSpin ||
              currentTomePrime?.tome?.trans_progress === "progress") && (
              <div className="ai_on_doc">
                <span className="spinning">
                  <AiOutlineLoading3Quarters />
                </span>{" "}
                Translation IA is applied, please wait...
              </div>
            )}
            <div className="edition_logo">
              {/* <img src={M_logo} alt="MangasIO_Logo" /> */}
              <img
                src={LogoMangas}
                alt="mySvgImage"
                onClick={() => navigate("/series")}
              />
              <Link
                to={"/tome/" + currentTome?.tome?.fk_serie}
                title="Back to tomes"
                className="back"
              >
                <IoIosArrowBack />
              </Link>
            </div>
            <div className="edition_search">
              <div className="input">
                {relatedSerie?.titre} {">"} {currentTome?.tome?.nom}
              </div>
            </div>
            <div
              className="show_due"
              title="show due"
              style={
                coordsSelectedImg?.trans_status !== "trans"
                  ? { opacity: "0.5", cursor: "not-allowed" }
                  : {}
              }
            >
              <span
                onClick={
                  coordsSelectedImg?.trans_status === "trans"
                    ? showDueHandler
                    : null
                }
                style={
                  showDue
                    ? { borderColor: "#2c262f" }
                    : !showDue && coordsSelectedImg?.trans_status !== "trans"
                    ? { opacity: "0.5", cursor: "not-allowed" }
                    : {}
                }
              >
                <img
                  src={show_due}
                  style={
                    coordsSelectedImg?.trans_status === "trans"
                      ? {}
                      : { opacity: "0.5", cursor: "not-allowed" }
                  }
                  alt="show duo"
                ></img>
              </span>
            </div>
            {allSousDocsValid && (
              <div className="show_due">
                <span onClick={showExportHandler}>
                  <FaFileExport />
                </span>
              </div>
            )}
            <div
              className="show_due"
              title="settings"
              style={
                currentTomePrime?.tome?.auto_progress === "progress"
                  ? { opacity: "0.5", cursor: "not-allowed" }
                  : {}
              }
            >
              <Link
                onClick={
                  currentTomePrime?.tome?.auto_progress === "progress"
                    ? null
                    : () => setShowSettings(true)
                }
              >
                <IoSettingsSharp />
              </Link>
            </div>
            <div
              id="ai"
              className="show_due"
              style={
                bubbleAllSpin ||
                transAllSpin ||
                currentTomePrime?.tome?.trans_progress === "progress"
                  ? { opacity: "0.5", cursor: "not-allowed" }
                  : {}
              }
            >
              <span title="Apply AI on the entire document">
                <PiMagicWandFill />
              </span>
              {(!bubbleAllSpin ||
                !transAllSpin ||
                currentTomePrime?.tome?.trans_progress === "done") && (
                <div className="ai_sublist">
                  <span
                    className="ai_btn"
                    onClick={
                      bubbleAll?.val === true ||
                      currentTomePrime?.tome?.apply_bubble ||
                      currentTomePrime?.tome?.auto_progress !== "done"
                        ? null
                        : applyBubbleOnDoc
                    }
                    title={
                      bubbleAll?.val === true ||
                      currentTomePrime?.tome?.apply_bubble ||
                      currentTomePrime?.tome?.auto_progress !== "done"
                        ? "Bubble AI is already applied"
                        : "Apply bubble AI on all pages"
                    }
                    style={
                      bubbleAll?.val === true ||
                      currentTomePrime?.tome?.apply_bubble ||
                      currentTomePrime?.tome?.auto_progress !== "done"
                        ? { opacity: "0.5", cursor: "not-allowed" }
                        : {}
                    }
                  >
                    Bubble
                  </span>
                  <span
                    className="ai_btn"
                    onClick={
                      transAll?.val === true ||
                      currentTomePrime?.tome?.apply_trans ||
                      !currentTomePrime?.tome?.apply_bubble ||
                      currentTomePrime?.tome?.trans_progress === "progress"
                        ? null
                        : applyTransOnDoc
                    }
                    title={
                      transAll?.val === true ||
                      currentTomePrime?.tome?.apply_trans ||
                      currentTomePrime?.tome?.trans_progress === "progress"
                        ? "Translation is already applied"
                        : "Apply Translation AI on all pages"
                    }
                    style={
                      transAll?.val === true ||
                      currentTomePrime?.tome?.apply_trans ||
                      !currentTomePrime?.tome?.apply_bubble ||
                      currentTomePrime?.tome?.trans_progress === "progress"
                        ? { opacity: "0.5", cursor: "not-allowed" }
                        : {}
                    }
                  >
                    Translation
                  </span>
                </div>
              )}
            </div>
            <div className="show_notif">
              <div
                id="notif"
                className="notif"
                title="Notifications"
                onClick={showHideNotif}
                style={
                  newNotifications.length !== 0 ? { color: "#bd2969" } : {}
                }
              >
                <FaBell id="notif" />
              </div>
              <div className="num_of">
                {newNotifications?.length < 10
                  ? newNotifications?.length
                  : "+9"}
              </div>
            </div>
            <div className="edition_avatar">
              <div
                id="avatar"
                title={loggedUser?.username}
                className="avatar"
                onClick={showHideSubList}
                style={
                  toggleSubList
                    ? {
                        border: ".15rem solid rgb(214, 65, 10)",
                        color: "rgb(214, 65, 10)",
                      }
                    : { border: "none", color: "black" }
                }
              >
                {loggedUser?.username && loggedUser?.username[0]?.toUpperCase()}
              </div>
              {usersOnline?.map((u, i) => {
                if (u?.online && u?.location === currentTome?.tome?._id) {
                  return (
                    <div
                      key={i}
                      id="avatar"
                      className="avatar"
                      title={u.nom_utilisateur}
                      style={{ left: `${(i + 1) * 2.5}rem` }}
                    >
                      {u?.nom_utilisateur &&
                        u?.nom_utilisateur[0]?.toUpperCase()}
                    </div>
                  );
                }
              })}
              {toggleSubList && (
                <div className="sub_list">
                  <Link className="item" to="/profile">
                    Settings
                  </Link>
                  <Link className="item" to="/logout">
                    Sign out
                  </Link>
                </div>
              )}

              {toggleNotif && (
                <div className="notif_list">
                  {notifications?.length !== 0 ? (
                    [...notifications].reverse()?.map((n, i) => {
                      return (
                        <span
                          key={i}
                          className="nofit_item"
                          style={
                            n.statut === "seen"
                              ? { backgroundColor: "#1510188f" }
                              : { backgroundColor: "#bd2969" }
                          }
                        >
                          {n.contenu}
                        </span>
                      );
                    })
                  ) : (
                    <p
                      style={{
                        textAlign: "center",
                        fontSize: ".8rem",
                        color: "#e8e5e5",
                      }}
                    >
                      No notifications yet !!
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="edition_content">
            {/* left bar */}
            <div className="left_section">
              {imgs?.map((ele, idx) => (
                <div id={idx + 1} key={idx + 1} className="splitted_img">
                  <img
                    src={ele.src}
                    alt={ele.path}
                    onClick={selectedImg}
                    id={idx + 1}
                  />
                  {sousDocs[idx]?.validation === true && (
                    <span className="dot">
                      <GrValidate />
                    </span>
                  )}
                  {sousDocs[idx]?.hasComment === true && (
                    <span className="hasComment">
                      <FaRegComment />
                    </span>
                  )}
                  {sousDocs[idx]?.page_status === "done" &&
                    sousDocs[idx]?.trans_status === "trans" &&
                    sousDocs[idx]?.validation === false && (
                      <span className="page_status">
                        <MdTranslate />
                      </span>
                    )}
                  {sousDocs[idx]?.page_status === "done" &&
                    sousDocs[idx]?.trans_status !== "trans" &&
                    sousDocs[idx]?.validation === false && (
                      <img
                        src={detection}
                        className="page_status_img"
                        alt="icon"
                      />
                    )}
                  <span className="pageNum">{idx + 1}</span>
                </div>
              ))}
            </div>
            {/* middle section */}
            <div
              className="middle_section"
              style={
                !showDue && showHideSlide
                  ? { width: "54%" }
                  : !showDue && !showHideSlide
                  ? { width: "88%" }
                  : {}
              }
            >
              <div className="middle_section_header">
                <span className="ref_name">
                  Page {pageNum} -{" "}
                  {coordsSelectedImg?.trans_status === "trans"
                    ? currentTome?.tome?.langue_cible === "en_gb"
                      ? "English"
                      : currentTome?.tome?.langue_cible === "FR"
                      ? "French"
                      : currentTome?.tome?.langue_cible === "es"
                      ? "Spanish"
                      : "..."
                    : "Original Version"}
                </span>
                <div className="btns_block">
                  {/* preview export */}
                  {coordsSelectedImg?.trans_status === "trans" && (
                    <span
                      className="showOV"
                      onClick={showPreviewExport}
                      title="see how this page will look on export"
                    >
                      <span className="change_icon">
                        <IoIosEye />
                      </span>
                      <span className="change_text">&nbsp;Preview</span>
                    </span>
                  )}
                  {coordsSelectedImg?.trans_status === "trans" && (
                    <span
                      className="showOV"
                      onClick={showVOImage}
                      title="show original version"
                      style={
                        showVO
                          ? {
                              borderColor: "rgb(214, 65, 10)",
                              color: "rgb(214, 65, 10)",
                            }
                          : {}
                      }
                    >
                      <span className="change_icon">
                        <MdTranslate />
                      </span>
                      <span className="change_text">&nbsp;Show OV</span>
                    </span>
                  )}

                  {coordsSelectedImg?.trans_status === "trans" && (
                    <span
                      id="change"
                      className="change"
                      title="click to see the drop list"
                      onClick={exportListHandler}
                    >
                      <span id="change_icon" className="change_icon">
                        <MdOutlineContentCopy />
                      </span>
                      <span id="change_text" className="change_text">
                        &nbsp;Change
                      </span>
                      {exportList && (
                        <div id="export_list" className="export_list">
                          <ul>
                            <li onClick={openImportFile}>Upload</li>
                            <li onClick={downloadFile}>Download</li>
                          </ul>
                        </div>
                      )}
                    </span>
                  )}
                </div>
                <input
                  type="file"
                  id="importFile"
                  style={{ display: "none" }}
                  onChange={importFileHandler}
                />
                {/* <form style={{ display: 'none' }}>
                                    <input type="file" id='importFile' style={{ display: 'none' }} onChange={importFileHandler} />
                                </form> */}
              </div>
              <div className="middle_section_main">
                {imgs?.length === currentTome?.sousDocumentVO?.length ? (
                  <div className="active_img" id="active_img">
                    {imageLoaded === true ? (
                      <>
                        <img
                          src={showVO ? activeImg : emptyBubbleImg || activeImg}
                          alt="Active"
                          onLoad={handleImageLoad}
                          onDragStart={(e) => e.preventDefault()}
                        />
                        <a
                          href={emptyBubbleImg}
                          id="downloadThisImage"
                          download={activeImgIdx}
                          style={{ display: "none" }}
                        ></a>
                        <SpotElements
                          coordsSelectedImg={coordsSelectedImg}
                          selectedTrans={selectedTransTwo}
                          showVO={showVO}
                          showDue={showDue}
                          showHideSlide={showHideSlide}
                          imageHeight={imageHeight}
                          imageWidth={imageWidth}
                          originalHeight={originalHeight}
                          originalWidth={originalWidth}
                          deleteZone={deleteZone}
                          handleMouseDown={handleMouseDown}
                          isLayered={currentTome?.tome?.isLayered}
                        />
                      </>
                    ) : (
                      <div className="hold_on">
                        <img src={dog_logo} alt="Dog_Logo" />
                        <h3>preparing page, please wait...</h3>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="hold_on">
                    <img src={dog_logo} alt="Dog_Logo" />
                    <h3>
                      Loading images,{" "}
                      {`( ${imgs?.length} / ${currentTome?.sousDocumentVO?.length} )`}{" "}
                      please wait...
                    </h3>
                  </div>
                )}
              </div>
            </div>
            {/* right section */}
            {showDue && (
              <div className="right_section">
                <div className="right_section_header">
                  <span className="ref_name">
                    Page {pageNum} - Original Version
                  </span>
                  {/* <span className='change' onClick={exportListHandlerVO}>
                                    <span className='change_icon'><MdOutlineContentCopy /></span>
                                    <span className='change_text'>&nbsp;Change</span>
                                    {exportListVO && <div className="export_list">
                                        <ul>
                                            <li onClick={openImportFile}>Import</li>
                                            <li onClick={downloadFile}>Export</li>
                                        </ul>
                                    </div>}
                                </span> */}
                  <form style={{ display: "none" }}>
                    <input
                      type="file"
                      id="importFile"
                      style={{ display: "none" }}
                      onChange={importFileHandler}
                    />
                  </form>
                </div>
                <div className="right_section_main">
                  <div className="active_img" id="active_img">
                    <img
                      src={activeImg}
                      alt="Active"
                      onLoad={handleImageLoad}
                    />
                    <a
                      href={activeImg}
                      id="downloadThisImage"
                      download={activeImgIdx}
                      style={{ display: "none" }}
                    ></a>
                    {coordsSelectedImg?.sous_images?.map((e, i) => {
                      return (
                        <div
                          id={`spote-${i}`}
                          className="spote"
                          key={i}
                          style={{
                            position: "absolute",
                            top: `${
                              (imageHeight * e.coord.Y) / originalHeight
                            }px`,
                            left: `${
                              (imageWidth * e.coord.X) / originalWidth
                            }px`,
                            width: `${
                              (imageWidth * e.coord.W) / originalWidth
                            }px`,
                            height: `${
                              (imageHeight * e.coord.H) / originalHeight
                            }px`,
                            border: `1.5px solid red`,
                          }}
                        >
                          <span className="ref_spot">
                            {e?.name_sous_image
                              ?.split(".")[0]
                              ?.replace("_", "-")}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            )}
            <div
              className="edition_content_slide"
              style={{ right: showHideSlide ? "0" : "calc(2rem - 35vw)" }}
            >
              <div className="openClose" onClick={showAndHideSlide}>
                <span
                  style={{
                    transform: showHideSlide
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                  }}
                >
                  <MdArrowBackIosNew />
                </span>
              </div>
              <div className="texts_zone">
                <div className="texts_zone_header">
                  <span className="trans_icon">
                    <MdTranslate />
                  </span>
                  {coordsSelectedImg?.sous_images?.length === 0 ? (
                    <h2>Step 1 - Bubble Detection</h2>
                  ) : (
                    <h2>
                      Step 2 - Translation to{" "}
                      {currentTome?.tome?.langue_cible === "en_gb"
                        ? "English"
                        : currentTome?.tome?.langue_cible === "FR"
                        ? "French"
                        : currentTome?.tome?.langue_cible === "es"
                        ? "Spanish"
                        : "..."}
                    </h2>
                  )}
                  {/* <div className="progress">{`${imgs?.length} / ${currentTome?.sousDocumentVO?.length}`}</div> */}
                  {(validationPage || coordsSelectedImgStored?.validation) && (
                    <div className="valid_page">
                      <GrValidate />
                    </div>
                  )}
                </div>
                <div
                  className="texts_zone_content"
                  style={
                    selectedTrans?.trans_status === "trans"
                      ? { overflowY: "auto" }
                      : { overflowY: "hidden" }
                  }
                >
                  {(coordsSelectedImg?.page_status === "" ||
                    coordsSelectedImg?.page_status === "auto") &&
                    (coordsSelectedImg?.trans_status === "" ||
                      coordsSelectedImg?.trans_status === "done") && (
                      <div className="texts_zone_content_start">
                        <img src={dog_logo} alt="Dog_Logo" />
                        <h3>Launch the bubbles detection AI!</h3>
                        <p>
                          Before starting the translation, you need to detect
                          the bubbles and choose the ones that should be cleaned
                          !
                        </p>
                        {currentTome?.tome?.isLayered && (
                          <>
                            <button
                              onClick={
                                coordsSelectedImg?.validation ||
                                coordsSelectedImg?.page_status === "" ||
                                bubbleAllSpin ||
                                transAllSpin
                                  ? null
                                  : () =>
                                      detectBubbles(coordsSelectedImg?.id_page)
                              }
                              title={
                                coordsSelectedImg.page_status === "" ||
                                bubbleAllSpin ||
                                transAllSpin
                                  ? "Please wait, Auto AI process is in progress..."
                                  : "Let's Go"
                              }
                              style={
                                sousDocs[pageNum - 1]?.validation ||
                                coordsSelectedImg?.page_status === "" ||
                                bubbleAllSpin ||
                                transAllSpin
                                  ? { opacity: "0.5", cursor: "not-allowed" }
                                  : {}
                              }
                            >
                              {" "}
                              {getCoords === "Waiting..." ||
                              coordsSelectedImg.page_status === "" ? (
                                <span className="creating img">
                                  <AiOutlineLoading3Quarters />
                                </span>
                              ) : (
                                <img
                                  src={detection}
                                  className="img"
                                  alt="icon"
                                />
                              )}{" "}
                              Detect bubbles
                            </button>
                            <p className="or">Or</p>
                            <button
                              className="validate_page"
                              type="button"
                              onClick={
                                coordsSelectedImg?.validation ||
                                coordsSelectedImg?.page_status === "" ||
                                bubbleAllSpin ||
                                transAllSpin
                                  ? null
                                  : validateThisPage
                              }
                              title={
                                coordsSelectedImg.page_status === "" ||
                                bubbleAllSpin ||
                                transAllSpin
                                  ? "Please wait, Auto AI process is in progress..."
                                  : "Skip detection and validate this page"
                              }
                              style={
                                sousDocs[pageNum - 1]?.validation ||
                                coordsSelectedImg?.page_status === "" ||
                                bubbleAllSpin ||
                                transAllSpin
                                  ? { opacity: "0.5", cursor: "not-allowed" }
                                  : {}
                              }
                            >
                              {validationText}
                            </button>
                          </>
                        )}
                      </div>
                    )}
                  {coordsSelectedImg?.page_status === "done" &&
                  (coordsSelectedImg?.trans_status === "done" ||
                    coordsSelectedImg?.trans_status === "") &&
                  imgs?.length === currentTome?.sousDocumentVO?.length ? (
                    <div className="texts_zone_content_start">
                      <img src={dog_logo} alt="Dog_Logo" />
                      <h3>{spots} bubbles detected!</h3>
                      {currentTome?.tome?.isLayered ? (
                        <p>
                          Launch the translation assistant on this page from the
                          button below or you can launch it on the whole
                          document, you can find it on the right of the
                          notifications icon.
                          <b>
                            Just make sure that all the pages are passed from
                            Bubble IA
                          </b>
                        </p>
                      ) : (
                        <p>
                          Make sure to remove all the bubbles you do not want to
                          translate automatically and then, launch the
                          translation assistant on the whole document, you can
                          find it on the right of the notifications icon.
                          <b>
                            Just make sure that all the pages are passed from
                            Bubble IA
                          </b>
                        </p>
                      )}
                      {spots !== 0 && currentTome?.tome?.isLayered && (
                        <button
                          onClick={
                            coordsSelectedImg?.trans_status === "done" &&
                            !transAllSpin
                              ? () => translateBubbles(activeImgIdx)
                              : null
                          }
                          title={
                            coordsSelectedImg.trans_status !== "done"
                              ? "Please wait, Translation is in progress..."
                              : "Let's Go"
                          }
                          style={
                            coordsSelectedImg?.trans_status === "done" &&
                            !transAllSpin
                              ? { gap: ".5rem" }
                              : {
                                  gap: ".5rem",
                                  opacity: "0.5",
                                  cursor: "not-allowed",
                                }
                          }
                        >
                          {isTranslated === "Please Wait..." ? (
                            <span className="creating trans_icon">
                              <AiOutlineLoading3Quarters />
                            </span>
                          ) : (
                            <span className="trans_icon">
                              <MdTranslate />
                            </span>
                          )}{" "}
                          Launch translation
                        </button>
                      )}
                      {spots === 0 && (
                        <button
                          className="validate_page"
                          type="button"
                          onClick={
                            coordsSelectedImg?.validation ||
                            coordsSelectedImg?.page_status === ""
                              ? null
                              : validateThisPage
                          }
                          title={
                            coordsSelectedImg.page_status === ""
                              ? "Please wait, Auto AI process is in progress..."
                              : "Let's Go"
                          }
                          style={
                            validationPage ||
                            coordsSelectedImg?.validation ||
                            coordsSelectedImg?.page_status === ""
                              ? { opacity: "0.5", cursor: "not-allowed" }
                              : {}
                          }
                        >
                          Validate Page
                        </button>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                  {coordsSelectedImg?.sous_images?.length === 0 && (
                    <div className="texts_zone_content_start">
                      <img src={dog_logo} alt="Dog_Logo" />
                      <h3>{spots} bubbles detected! Page is empty</h3>
                      <p>
                        It seems there are no bubbles detected on this page,
                        <b>You can press the button below to validate it</b>
                      </p>
                      {spots === 0 && (
                        <button
                          className="validate_page"
                          type="button"
                          onClick={
                            coordsSelectedImg?.validation
                              ? null
                              : validateThisPage
                          }
                          title="Let's Go"
                          style={
                            validationPage || coordsSelectedImg?.validation
                              ? { opacity: "0.5", cursor: "not-allowed" }
                              : {}
                          }
                        >
                          Validate Page
                        </button>
                      )}
                    </div>
                  )}
                  {hasTrans === "loading" ? (
                    <div className="texts_zone_content_start">
                      <img src={dog_logo} alt="Dog_Logo" />
                      <h3>Please Wait...!</h3>
                    </div>
                  ) : (
                    ""
                  )}
                  {hasTrans === true &&
                  coordsSelectedImg?.trans_status === "trans" &&
                  selectedTrans?.sous_images &&
                  relatedSerie?.titre ? (
                    <>
                      <TextZone
                        setValidationPage={setValidationPage}
                        loggedUser={loggedUser}
                        setAllTextsValid={setAllTextsValid}
                        trans={selectedTrans}
                        textUpdated={textUpdated}
                        setSelectedTrans={setSelectedTrans}
                        setPageValidated={setPageValidated}
                        currentTome={currentTome}
                        relatedSerie={relatedSerie}
                        group={group}
                        pageHasComment={pageHasComment}
                        unvalidatePage={unvalidatePage}
                      />
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* import file pop up  */}
          {openImportedFile && (
            <div className="import_popup">
              <div className="pop_up">
                <h4>Are you sure you want to upload this file?</h4>
                {isUploaded && (
                  <span className="importing">
                    <AiOutlineLoading3Quarters />
                  </span>
                )}
                <div className="btns_block">
                  <button
                    className="cancel"
                    onClick={closeImportFile}
                    disabled={isUploaded}
                  >
                    Cancel
                  </button>
                  <button
                    className="upload"
                    onClick={importThisFile}
                    disabled={isUploaded}
                  >
                    Upload
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
        {showExportPdf && (
          <div className="expoer_pdf_section">
            <div className="expoer_pdf_section_btns">
              <button
                onClick={
                  allTrans?.length === 0 || showProgress
                    ? null
                    : showExportHandler
                }
                style={
                  showProgress || allTrans?.length === 0
                    ? { opacity: "0.5", cursor: "not-allowed" }
                    : {}
                }
              >
                Back to work {allTrans?.length}
              </button>
              {showProgress && (
                <span className="export_progress">
                  Please wait, your document is being prepared for download.
                  page {currentPage} of {allErasedImgs?.length}
                </span>
              )}
              {allErasedImgs?.length !== 0 && allTrans?.length !== 0 && (
                <button
                  onClick={showProgress ? null : handleDownloadPDF}
                  style={
                    showProgress
                      ? { opacity: "0.5", cursor: "not-allowed" }
                      : {}
                  }
                >
                  {showProgress ? (
                    <span className="creating">
                      <AiOutlineLoading3Quarters />
                    </span>
                  ) : (
                    "Export as pdf"
                  )}
                </button>
              )}
            </div>
            <div className="expoer_pdf_section_main">
              {allErasedImgs?.length === sousDocs?.length &&
              allTrans?.length === sousDocs?.length ? (
                allErasedImgs?.map((img, i) => {
                  return (
                    <div
                      key={i + 1}
                      className="active_img_export"
                      id={`active_img_${i + 1}`}
                    >
                      <img src={img.src} alt={img.id_page} />
                      {allTrans[i]?.trans_status !== "done" &&
                        originalWandH?.length !== 0 &&
                        allTrans[i]?.sous_images?.map((e, i) => {
                          return (
                            <div
                              id={`spote-${e._id}`}
                              className="spote"
                              key={i}
                              style={{
                                position: "absolute",
                                top: `${e.coord.Y / toRem}rem`,
                                left: `${e.coord.X / toRem}rem`,
                                width: `${e.coord.W / toRem}rem`,
                                height: `${e.coord.H / toRem}rem`,
                                transform: `rotate(${e.coord.R}deg)`,
                                padding: `${
                                  (originalWandH[i]?.o_h * (toRem / 10)) /
                                  originalWandH[i]?.o_w /
                                  toRem
                                }rem`,
                              }}
                            >
                              <svg
                                viewBox="0 0 100 100"
                                preserveAspectRatio="xMidYMid meet"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  overflow: "visible",
                                }}
                              >
                                {/* Outline Text */}
                                {e?.stroke_applied === true && (
                                  <text
                                    x="50"
                                    y="50"
                                    textAnchor="middle"
                                    dominantBaseline="middle"
                                    fill="none"
                                    stroke={`rgb(${e?.stroke_color})`}
                                    strokeWidth={e.stroke_blur}
                                    style={{
                                      fontFamily: e?.fontName || "Wildjess",
                                      fontSize: `${e?.size}em`,
                                      fontWeight: e?.fontWeight,
                                      fontStyle: e?.fontStyle,
                                    }}
                                  >
                                    {e?.text_translated
                                      ?.split("\n")
                                      .map((line, idx, arr) => (
                                        <tspan
                                          key={`outline-${idx}`}
                                          x="50"
                                          dy={
                                            idx === 0
                                              ? `${
                                                  (-(arr.length - 1) *
                                                    +e?.stroke_opacity) /
                                                  2
                                                }em`
                                              : `${+e?.stroke_opacity}em`
                                          }
                                        >
                                          {line}
                                        </tspan>
                                      ))}
                                  </text>
                                )}

                                {/* Fill Text */}
                                <text
                                  x="50"
                                  y="50"
                                  textAnchor="middle"
                                  dominantBaseline="middle"
                                  fill={e?.color || "black"}
                                  stroke="none"
                                  style={{
                                    fontFamily: e?.fontName || "Wildjess",
                                    fontSize: `${e?.size}em`,
                                    fontWeight: e?.fontWeight,
                                    fontStyle: e?.fontStyle,
                                  }}
                                >
                                  {e?.text_translated
                                    ?.split("\n")
                                    .map((line, idx, arr) => (
                                      <tspan
                                        key={`fill-${idx}`}
                                        x="50"
                                        dy={
                                          idx === 0
                                            ? `${
                                                (-(arr.length - 1) *
                                                  +e?.stroke_opacity) /
                                                2
                                              }em`
                                            : `${+e?.stroke_opacity}em`
                                        }
                                      >
                                        {line}
                                      </tspan>
                                    ))}
                                </text>
                              </svg>
                            </div>
                          );
                        })}
                    </div>
                  );
                })
              ) : (
                <div className="export_pdf_waiting">
                  {sousDocs?.length === progress && (
                    <p>Preparing the document...</p>
                  )}
                  <progress value={progress} max={sousDocs?.length}></progress>
                </div>
              )}
            </div>
          </div>
        )}
        {previewExport && (
          <div className="expoer_pdf_section">
            <div className="expoer_pdf_section_btns">
              <button onClick={() => setPreviewExport((prev) => !prev)}>
                Back to work
              </button>
            </div>
            <div className="expoer_pdf_section_main">
              <div className="active_img_export">
                {imageLoaded === true && previewExportReady === true ? (
                  <>
                    <img
                      src={showVO ? activeImg : emptyBubbleImg || activeImg}
                      alt="Active"
                      onLoad={handleImageLoad}
                      onDragStart={(e) => e.preventDefault()}
                    />
                    {selectedTransTwo?.sous_images?.map((e) => {
                      return (
                        <div
                          id={`spote-${e._id}`}
                          className="spote"
                          key={e._id}
                          style={{
                            position: "absolute",
                            top: `${e.coord.Y / toRem}rem`,
                            left: `${e.coord.X / toRem}rem`,
                            width: `${e.coord.W / toRem}rem`,
                            height: `${e.coord.H / toRem}rem`,
                            transform: `rotate(${e.coord.R}deg)`,
                            padding: `${
                              (originalHeight * (toRem / 10)) /
                              originalWidth /
                              toRem
                            }rem`,
                          }}
                        >
                          <svg
                            viewBox="0 0 100 100"
                            preserveAspectRatio="xMidYMid meet"
                            style={{
                              width: "100%",
                              height: "100%",
                              overflow: "visible",
                            }}
                          >
                            {/* Outline Text */}
                            {e?.stroke_applied === true && (
                              <text
                                x="50"
                                y="50"
                                textAnchor="middle"
                                dominantBaseline="middle"
                                fill="none"
                                stroke={`rgb(${e?.stroke_color})`}
                                strokeWidth={e.stroke_blur}
                                style={{
                                  fontFamily: e?.fontName || "Wildjess",
                                  fontSize: `${e?.size}em`,
                                  fontWeight: e?.fontWeight,
                                  fontStyle: e?.fontStyle,
                                }}
                              >
                                {e?.text_translated
                                  ?.split("\n")
                                  .map((line, idx, arr) => (
                                    <tspan
                                      key={`outline-${idx}`}
                                      x="50"
                                      dy={
                                        idx === 0
                                          ? `${
                                              (-(arr.length - 1) *
                                                +e?.stroke_opacity) /
                                              2
                                            }em`
                                          : `${+e?.stroke_opacity}em`
                                      }
                                    >
                                      {line}
                                    </tspan>
                                  ))}
                              </text>
                            )}

                            {/* Fill Text */}
                            <text
                              x="50"
                              y="50"
                              textAnchor="middle"
                              dominantBaseline="middle"
                              fill={e?.color || "black"}
                              stroke="none"
                              style={{
                                fontFamily: e?.fontName || "Wildjess",
                                fontSize: `${e?.size}em`,
                                fontWeight: e?.fontWeight,
                                fontStyle: e?.fontStyle,
                              }}
                            >
                              {e?.text_translated
                                ?.split("\n")
                                .map((line, idx, arr) => (
                                  <tspan
                                    key={`fill-${idx}`}
                                    x="50"
                                    dy={
                                      idx === 0
                                        ? `${
                                            (-(arr.length - 1) *
                                              +e?.stroke_opacity) /
                                            2
                                          }em`
                                        : `${+e?.stroke_opacity}em`
                                    }
                                  >
                                    {line}
                                  </tspan>
                                ))}
                            </text>
                          </svg>
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <div className="hold_on">
                    <img src={dog_logo} alt="Dog_Logo" />
                    <h3>preparing page preview, please wait...</h3>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {showSettings && (
          <div className="setting_container">
            <div className="setting_header">
              <div className="setting_logo">
                <img
                  src={require("../../assets/logo mangasio.svg").default}
                  alt="mySvgImage"
                />
                <Link
                  onClick={
                    isForceValidation ? null : () => setShowSettings(false)
                  }
                  className="back"
                  style={
                    isForceValidation
                      ? { opacity: "0.5", cursor: "not-allowed" }
                      : {}
                  }
                >
                  <IoIosArrowBack />
                </Link>
              </div>
              <div className="setting_search">
                <div className="input">
                  {relatedSerie?.titre} {">"} {currentTome?.tome?.nom} {">"}{" "}
                  settings
                </div>
              </div>
              <div className="setting_avatar">
                <div
                  id="avatar"
                  className="avatar"
                  onClick={showHideSubList}
                  style={
                    toggleSubList
                      ? {
                          border: "1px solid rgb(214, 65, 10)",
                          color: "rgb(214, 65, 10)",
                        }
                      : { border: "none", color: "black" }
                  }
                >
                  {loggedUser?.username &&
                    loggedUser?.username[0]?.toUpperCase()}
                </div>
                {toggleSubList && (
                  <div className="sub_list">
                    <Link className="item" to="/logout">
                      Sign out
                    </Link>
                  </div>
                )}
              </div>
            </div>
            <div className="setting_content">
              <h2>Settings</h2>
              <div className="setting_settings">
                <ul className="options">
                  <li
                    id="export"
                    style={
                      showExport
                        ? { color: "#775DA6", borderColor: "#775DA6" }
                        : { color: "#FFFFFF", borderColor: "#FFFFFF" }
                    }
                    onClick={isForceValidation ? null : toggleListSetting}
                  >
                    Export
                  </li>
                  <li
                    id="users"
                    style={
                      showUsers
                        ? { color: "#775DA6", borderColor: "#775DA6" }
                        : { color: "#FFFFFF", borderColor: "#FFFFFF" }
                    }
                    onClick={isForceValidation ? null : toggleListSetting}
                  >
                    Users
                  </li>
                  <li
                    id="police"
                    style={
                      showPolice
                        ? { color: "#775DA6", borderColor: "#775DA6" }
                        : { color: "#FFFFFF", borderColor: "#FFFFFF" }
                    }
                    onClick={isForceValidation ? null : toggleListSetting}
                  >
                    Default Text Style
                  </li>
                </ul>
                <div className="setting_details">
                  {showExport && (
                    <div className="setting_details_content">
                      <div className="input_block">
                        <label htmlFor="new_role">Document type</label>
                        <select>
                          <option value="pdf">PDF</option>
                        </select>
                      </div>
                      <div className="input_block">
                        <label>Forcing the validation of all the tome</label>
                        <button
                          onClick={
                            !currentTomePrime?.tome?.apply_trans ||
                            isForceValidation
                              ? null
                              : forceValidateAllTome
                          }
                          style={
                            !currentTomePrime?.tome?.apply_trans ||
                            isForceValidation
                              ? { opacity: "0.5", cursor: "not-allowed" }
                              : {}
                          }
                          className="validate_all_doc"
                        >
                          {isForceValidation && (
                            <span className="creating img">
                              <AiOutlineLoading3Quarters />
                            </span>
                          )}{" "}
                          Validate all tome
                        </button>
                      </div>
                    </div>
                  )}
                  {showUsers && (
                    <div className="setting_details_group">
                      <div className="mumbers">
                        {group?.map((u, i) => {
                          return (
                            <div
                              key={i}
                              className="mumber_avatar"
                              style={{ left: `${i * 2}rem` }}
                              title={u?.nom_utilisateur}
                            >
                              {u?.nom_utilisateur[0]}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                  {showPolice && (
                    <div className="setting_details_police">
                      <div className="police_left">
                        <div className="police_block">
                          <label htmlFor="fontFamily">Font Family</label>
                          <select
                            name="fontName"
                            id="fontsDefault"
                            className="fontsDefault"
                            value={
                              defaultPolice?.fontName
                                ? defaultPolice?.fontName
                                : "Wildjess"
                            }
                            onChange={defaultPoliceChange}
                          >
                            <option value="Arial">Arial</option>
                            <option value="Poppins">Poppins</option>
                            <option value="Aladar">Aladar</option>
                            <option value="Komikula Bold">Komikula Bold</option>
                            <option value="Komikula">Komikula</option>
                            <option value="Wildjess">Wildjess</option>
                            <option value="Wildjess Italic">
                              Wildjess Italic
                            </option>
                            <option value="Boorsok">Boorsok</option>
                            <option value="Jester">Jester</option>
                            <option value="Palatino Linotype">
                              Palatino Linotype
                            </option>
                            <option value="Nafta">Nafta</option>
                            <option value="Satoshi italic">
                              Satoshi italic
                            </option>
                            <option value="Contour">Contour</option>
                            <option value="Komika boo">Komika boo</option>
                            <option value="Asmudila">Asmudila</option>
                            <option value="Fayuca">Fayuca</option>
                            <option value="Makasih">Makasih</option>
                            <option value="Geek a byte">Geek a byte</option>
                            <option value="Marker Monkey">Marker Monkey</option>
                            <option value="Koshari">Koshari</option>
                            <option value="Badaboom BB">Badaboom BB</option>
                            <option value="A Aha Wow">A Aha Wow</option>
                            <option value="Active">Active</option>
                          </select>
                        </div>

                        <div className="police_block">
                          <label htmlFor="fontSize">Font Size px</label>
                          <input
                            type="number"
                            name="size"
                            id="sizeDefault"
                            min={0}
                            step={0.1}
                            value={
                              defaultPolice?.size ? defaultPolice?.size : 1.2
                            }
                            onChange={defaultPoliceChange}
                          />
                        </div>

                        <div className="police_block">
                          <label htmlFor="fontWeight">Font Weight</label>
                          <select
                            name="fontWeight"
                            id="weightDefault"
                            value={
                              defaultPolice?.fontWeight
                                ? defaultPolice?.fontWeight
                                : "normal"
                            }
                            onChange={defaultPoliceChange}
                          >
                            <option value="lighter">lighter</option>
                            <option value="normal">normal</option>
                            <option value="bold">bold</option>
                            <option value="bolder">bolder</option>
                          </select>
                        </div>

                        <div className="police_block">
                          <label>Font Color</label>
                          <input
                            type="color"
                            name="color"
                            id="colorDefault"
                            value={
                              defaultPolice?.color
                                ? defaultPolice?.color
                                : "#000000"
                            }
                            onChange={defaultPoliceChange}
                          />
                        </div>

                        <div className="police_block_eye">
                          <label>Apply stroke :</label>
                          <div className="show_hide_stroke">
                            {defaultPolice?.stroke_applied ? (
                              <IoIosEye
                                style={{ cursor: "pointer", color: "#dddddd" }}
                                onClick={() =>
                                  onOffShadow(defaultPolice?.stroke_applied)
                                }
                                title="Click to disable stroke"
                              />
                            ) : (
                              <IoIosEyeOff
                                style={{ cursor: "pointer", color: "#dddddd" }}
                                onClick={() =>
                                  onOffShadow(defaultPolice?.stroke_applied)
                                }
                                title="Click to enable stroke"
                              />
                            )}
                          </div>
                        </div>

                        <div className="police_block">
                          <label>Stroke Color</label>
                          <input
                            type="color"
                            name="stroke_color"
                            id="strokeColorDefault"
                            value={
                              defaultPolice?.stroke_color
                                ? rgbToHex(defaultPolice?.stroke_color)
                                : "#000000"
                            }
                            onChange={defaultPoliceChange}
                          />
                        </div>

                        <div className="police_block">
                          <label htmlFor="strokeBlur">Stroke width</label>
                          {/* <input type="number" name="stroke_blur" id="sizeDefault" min={0} step={0.001} value={defaultPolice?.stroke_blur} onChange={defaultPoliceChange} /> */}
                          <input
                            type="range"
                            name="stroke_blur"
                            id="stroke_width"
                            min={0}
                            max={20}
                            step={0.1}
                            value={defaultPolice?.stroke_blur}
                            onChange={defaultPoliceChange}
                          />
                        </div>

                        <div className="police_block">
                          <label htmlFor="strokeOpacity">Line height</label>
                          <input
                            type="range"
                            name="stroke_opacity"
                            id="stroke_opacity"
                            min={1}
                            max={4}
                            step={0.1}
                            value={defaultPolice?.stroke_opacity}
                            onChange={defaultPoliceChangeOpacity}
                          />
                        </div>

                        <div className="police_block">
                          <label htmlFor="fontStyle">Font Style</label>
                          <select
                            name="fontStyle"
                            id="styleDefault"
                            value={
                              defaultPolice?.fontStyle
                                ? defaultPolice?.fontStyle
                                : "normal"
                            }
                            onChange={defaultPoliceChange}
                          >
                            <option value="italic">italic</option>
                            <option value="normal">normal</option>
                          </select>
                        </div>
                      </div>

                      <div className="police_right">
                        <svg
                          viewBox="0 0 100 100"
                          preserveAspectRatio="xMidYMid meet"
                          style={{
                            width: "100%",
                            height: "100%",
                            overflow: "visible",
                          }}
                        >
                          {/* Outline Text */}
                          {defaultPolice?.stroke_applied === true && (
                            <text
                              x="50"
                              y="50"
                              textAnchor="middle"
                              dominantBaseline="middle"
                              fill="none"
                              stroke={`rgb(${defaultPolice?.stroke_color})`}
                              strokeWidth={defaultPolice.stroke_blur}
                              style={{
                                fontFamily: `"${defaultPolice?.fontName}"`,
                                fontSize: `${defaultPolice?.size * 0.8}em`,
                                fontWeight: defaultPolice?.fontWeight,
                                fontStyle: defaultPolice?.fontStyle,
                              }}
                            >
                              {"Example\nxyz"
                                .split("\n")
                                .map((line, idx, arr) => (
                                  <tspan
                                    key={`outline-${idx}`}
                                    x="50"
                                    dy={
                                      idx === 0
                                        ? `${
                                            (-(arr.length - 1) *
                                              +defaultPolice?.stroke_opacity) /
                                            2
                                          }em`
                                        : `${+defaultPolice?.stroke_opacity}em`
                                    }
                                  >
                                    {line}
                                  </tspan>
                                ))}
                            </text>
                          )}

                          {/* Fill Text */}
                          <text
                            x="50"
                            y="50"
                            textAnchor="middle"
                            dominantBaseline="middle"
                            fill={defaultPolice?.color || "black"}
                            stroke="none"
                            style={{
                              fontFamily: `"${defaultPolice?.fontName}"`,
                              fontSize: `${defaultPolice?.size * 0.8}em`,
                              fontWeight: defaultPolice?.fontWeight,
                              fontStyle: defaultPolice?.fontStyle,
                            }}
                          >
                            {"Example\nxyz"
                              .split("\n")
                              .map((line, idx, arr) => (
                                <tspan
                                  key={`fill-${idx}`}
                                  x="50"
                                  dy={
                                    idx === 0
                                      ? `${
                                          (-(arr.length - 1) *
                                            +defaultPolice?.stroke_opacity) /
                                          2
                                        }em`
                                      : `${+defaultPolice?.stroke_opacity}em`
                                  }
                                >
                                  {line}
                                </tspan>
                              ))}
                          </text>
                        </svg>
                        <div className="valid_btn">
                          <button onClick={validateDefaultPolice}>
                            Confirm
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        <ToastContainer />
      </>
    );
  }
};

export default Edition;
